/* tslint:disable */
/* eslint-disable */
/**
 * data-collector-app API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 6.34.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 *
 * @export
 * @interface ActionDTO
 */
export interface ActionDTO {
    /**
     *
     * @type {string}
     * @memberof ActionDTO
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof ActionDTO
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof ActionDTO
     */
    'description'?: string;
    /**
     *
     * @type {any}
     * @memberof ActionDTO
     */
    'returnSchema'?: any;
    /**
     *
     * @type {Array<ArgumentInfoDTO>}
     * @memberof ActionDTO
     */
    'arguments'?: Array<ArgumentInfoDTO>;
}
/**
 *
 * @export
 * @interface ActivityLogEntry
 */
export interface ActivityLogEntry {
    /**
     *
     * @type {number}
     * @memberof ActivityLogEntry
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'timestamp'?: string;
    /**
     *
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'actorType'?: string;
    /**
     *
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'actorId'?: string;
    /**
     *
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'domain'?: string;
    /**
     *
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'entity'?: string;
    /**
     *
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'entityId'?: string;
    /**
     *
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'operation'?: string;
    /**
     *
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'summary'?: string;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof ActivityLogEntry
     */
    'details'?: { [key: string]: any; };
}
/**
 *
 * @export
 * @enum {string}
 */

export const AggregationType = {
    Sum: 'SUM',
    Mean: 'MEAN',
    Delta: 'DELTA',
    Min: 'MIN',
    Max: 'MAX',
    Newest: 'NEWEST',
    Oldest: 'OLDEST'
} as const;

export type AggregationType = typeof AggregationType[keyof typeof AggregationType];


/**
 *
 * @export
 * @interface ArgumentInfoDTO
 */
export interface ArgumentInfoDTO {
    /**
     *
     * @type {string}
     * @memberof ArgumentInfoDTO
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof ArgumentInfoDTO
     */
    'description'?: string;
    /**
     *
     * @type {any}
     * @memberof ArgumentInfoDTO
     */
    'argumentSchema'?: any;
}
/**
 *
 * @export
 * @enum {string}
 */

export const AttributeType = {
    None: 'NONE',
    Long: 'LONG',
    Double: 'DOUBLE',
    String: 'STRING',
    Dataset: 'DATASET',
    Datetime: 'DATETIME',
    Instant: 'INSTANT',
    File: 'FILE',
    Time: 'TIME',
    Timespan: 'TIMESPAN',
    ForeignKey: 'FOREIGN_KEY',
    MultiForeignKey: 'MULTI_FOREIGN_KEY',
    UserSignature: 'USER_SIGNATURE',
    Parameters: 'PARAMETERS',
    MultiValue: 'MULTI_VALUE'
} as const;

export type AttributeType = typeof AttributeType[keyof typeof AttributeType];


/**
 *
 * @export
 * @interface AuditLogQuery
 */
export interface AuditLogQuery {
    /**
     *
     * @type {string}
     * @memberof AuditLogQuery
     */
    'from'?: string;
    /**
     *
     * @type {string}
     * @memberof AuditLogQuery
     */
    'to'?: string;
    /**
     *
     * @type {string}
     * @memberof AuditLogQuery
     */
    'domain'?: string;
    /**
     *
     * @type {string}
     * @memberof AuditLogQuery
     */
    'entity'?: string;
    /**
     *
     * @type {string}
     * @memberof AuditLogQuery
     */
    'entityId'?: string;
    /**
     *
     * @type {string}
     * @memberof AuditLogQuery
     */
    'actorType'?: string;
    /**
     *
     * @type {string}
     * @memberof AuditLogQuery
     */
    'actorId'?: string;
    /**
     *
     * @type {number}
     * @memberof AuditLogQuery
     */
    'limit'?: number;
}
/**
 *
 * @export
 * @interface BackupEntry
 */
export interface BackupEntry {
    /**
     *
     * @type {number}
     * @memberof BackupEntry
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof BackupEntry
     */
    'readerId'?: string;
    /**
     *
     * @type {string}
     * @memberof BackupEntry
     */
    'timestamp'?: string;
    /**
     *
     * @type {UserInfo}
     * @memberof BackupEntry
     */
    'editor'?: UserInfo;
}
/**
 *
 * @export
 * @interface BasicMeterInfo
 */
export interface BasicMeterInfo {
    /**
     *
     * @type {string}
     * @memberof BasicMeterInfo
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof BasicMeterInfo
     */
    'meterName'?: string;
    /**
     *
     * @type {string}
     * @memberof BasicMeterInfo
     */
    'readerId'?: string;
}
/**
 *
 * @export
 * @interface BasicReaderInfo
 */
export interface BasicReaderInfo {
    /**
     *
     * @type {string}
     * @memberof BasicReaderInfo
     */
    'implementationKey'?: string;
    /**
     *
     * @type {boolean}
     * @memberof BasicReaderInfo
     */
    'enabled'?: boolean;
    /**
     *
     * @type {string}
     * @memberof BasicReaderInfo
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof BasicReaderInfo
     */
    'readerName'?: string;
    /**
     *
     * @type {Array<BasicMeterInfo>}
     * @memberof BasicReaderInfo
     */
    'meters'?: Array<BasicMeterInfo>;
    /**
     *
     * @type {string}
     * @memberof BasicReaderInfo
     */
    'lastModified'?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ChronoUnit = {
    Nanos: 'NANOS',
    Micros: 'MICROS',
    Millis: 'MILLIS',
    Seconds: 'SECONDS',
    Minutes: 'MINUTES',
    Hours: 'HOURS',
    HalfDays: 'HALF_DAYS',
    Days: 'DAYS',
    Weeks: 'WEEKS',
    Months: 'MONTHS',
    Years: 'YEARS',
    Decades: 'DECADES',
    Centuries: 'CENTURIES',
    Millennia: 'MILLENNIA',
    Eras: 'ERAS',
    Forever: 'FOREVER'
} as const;

export type ChronoUnit = typeof ChronoUnit[keyof typeof ChronoUnit];


/**
 *
 * @export
 * @enum {string}
 */

export const DataHoldMode = {
    ConsumeOnRead: 'CONSUME_ON_READ',
    ReturnMostRecent: 'RETURN_MOST_RECENT'
} as const;

export type DataHoldMode = typeof DataHoldMode[keyof typeof DataHoldMode];


/**
 *
 * @export
 * @enum {string}
 */

export const DatasetAccessType = {
    Normal: 'NORMAL',
    Continuous: 'CONTINUOUS',
    DataModelDay: 'DATA_MODEL_DAY'
} as const;

export type DatasetAccessType = typeof DatasetAccessType[keyof typeof DatasetAccessType];


/**
 *
 * @export
 * @interface DatasetCategoryDTO
 */
export interface DatasetCategoryDTO {
    /**
     *
     * @type {number}
     * @memberof DatasetCategoryDTO
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof DatasetCategoryDTO
     */
    'title'?: string;
    /**
     *
     * @type {number}
     * @memberof DatasetCategoryDTO
     */
    'defaultGroupId'?: number;
    /**
     *
     * @type {number}
     * @memberof DatasetCategoryDTO
     */
    'companyId'?: number;
    /**
     *
     * @type {DatasetType}
     * @memberof DatasetCategoryDTO
     */
    'defaultDatasetType'?: DatasetType;
    /**
     *
     * @type {string}
     * @memberof DatasetCategoryDTO
     */
    'defaultUnit'?: string;
    /**
     *
     * @type {boolean}
     * @memberof DatasetCategoryDTO
     */
    'isRemote'?: boolean;
}


/**
 *
 * @export
 * @enum {string}
 */

export const DatasetClass = {
    SimpleDataset: 'SIMPLE_DATASET',
    AdvancedDataset: 'ADVANCED_DATASET',
    CategorizedDataset: 'CATEGORIZED_DATASET',
    ElectricityDataset: 'ELECTRICITY_DATASET',
    ProcessedDataset: 'PROCESSED_DATASET',
    ProcessedIntegralDataset: 'PROCESSED_INTEGRAL_DATASET',
    ProcessedPriorityFirstDataset: 'PROCESSED_PRIORITY_FIRST_DATASET',
    ProcessedPythonDataset: 'PROCESSED_PYTHON_DATASET',
    CategorizedStringDataset: 'CATEGORIZED_STRING_DATASET',
    RemoteDataset: 'REMOTE_DATASET',
    RemoteStringDataset: 'REMOTE_STRING_DATASET',
    RemoteCategorizedDataset: 'REMOTE_CATEGORIZED_DATASET',
    DatacollectorDataset: 'DATACOLLECTOR_DATASET'
} as const;

export type DatasetClass = typeof DatasetClass[keyof typeof DatasetClass];


/**
 *
 * @export
 * @interface DatasetDTO
 */
export interface DatasetDTO {
    /**
     *
     * @type {string}
     * @memberof DatasetDTO
     */
    'datasetIdentifier'?: string;
    /**
     *
     * @type {string}
     * @memberof DatasetDTO
     */
    'datasetName'?: string;
    /**
     *
     * @type {string}
     * @memberof DatasetDTO
     */
    'datasetUnit'?: string;
}
/**
 *
 * @export
 * @interface DatasetDataInfoResponse
 */
export interface DatasetDataInfoResponse {
    /**
     * Dataset identifier in format \'id:class\'
     * @type {string}
     * @memberof DatasetDataInfoResponse
     */
    'identifier'?: string;
    /**
     *
     * @type {string}
     * @memberof DatasetDataInfoResponse
     */
    'title'?: string;
    /**
     *
     * @type {string}
     * @memberof DatasetDataInfoResponse
     */
    'unit'?: string;
    /**
     *
     * @type {Array<InstantDoubleValue>}
     * @memberof DatasetDataInfoResponse
     */
    'data'?: Array<InstantDoubleValue>;
    /**
     *
     * @type {number}
     * @memberof DatasetDataInfoResponse
     */
    'decimalPlaces'?: number;
    /**
     *
     * @type {number}
     * @memberof DatasetDataInfoResponse
     */
    'stringValueMapper'?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const DatasetDataType = {
    Decimal: 'DECIMAL',
    Integer: 'INTEGER',
    String: 'STRING'
} as const;

export type DatasetDataType = typeof DatasetDataType[keyof typeof DatasetDataType];


/**
 *
 * @export
 * @interface DatasetDataUpdateDTO
 */
export interface DatasetDataUpdateDTO {
    /**
     *
     * @type {number}
     * @memberof DatasetDataUpdateDTO
     */
    'datasetId'?: number;
    /**
     *
     * @type {Array<DatasetValue>}
     * @memberof DatasetDataUpdateDTO
     */
    'values'?: Array<DatasetValue>;
}
/**
 *
 * @export
 * @interface DatasetExtendedIdentifier
 */
export interface DatasetExtendedIdentifier {
    /**
     *
     * @type {any}
     * @memberof DatasetExtendedIdentifier
     */
    'datasetDBId'?: any;
    /**
     *
     * @type {DatasetClass}
     * @memberof DatasetExtendedIdentifier
     */
    'datasetClass'?: DatasetClass;
    /**
     *
     * @type {boolean}
     * @memberof DatasetExtendedIdentifier
     */
    'tagIdentifier'?: boolean;
    /**
     *
     * @type {string}
     * @memberof DatasetExtendedIdentifier
     */
    'title'?: string;
    /**
     *
     * @type {number}
     * @memberof DatasetExtendedIdentifier
     */
    'groupId'?: number;
    /**
     *
     * @type {string}
     * @memberof DatasetExtendedIdentifier
     */
    'units'?: string;
}


/**
 *
 * @export
 * @interface DatasetGroup
 */
export interface DatasetGroup {
    /**
     *
     * @type {number}
     * @memberof DatasetGroup
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof DatasetGroup
     */
    'title'?: string;
    /**
     *
     * @type {Array<DatasetGroup>}
     * @memberof DatasetGroup
     */
    'children'?: Array<DatasetGroup>;
}
/**
 *
 * @export
 * @interface DatasetInfo
 */
export interface DatasetInfo {
    /**
     * Dataset identifier in format \'id:class\'
     * @type {string}
     * @memberof DatasetInfo
     */
    'identifier'?: string;
    /**
     *
     * @type {string}
     * @memberof DatasetInfo
     */
    'title'?: string;
    /**
     *
     * @type {string}
     * @memberof DatasetInfo
     */
    'unit'?: string;
    /**
     *
     * @type {number}
     * @memberof DatasetInfo
     */
    'companyId'?: number;
    /**
     *
     * @type {DatasetType}
     * @memberof DatasetInfo
     */
    'dataType'?: DatasetType;
    /**
     *
     * @type {string}
     * @memberof DatasetInfo
     */
    'datasetClass'?: string;
    /**
     *
     * @type {DatasetAccessType}
     * @memberof DatasetInfo
     */
    'accessType'?: DatasetAccessType;
    /**
     *
     * @type {string}
     * @memberof DatasetInfo
     */
    'groupTitle'?: string;
    /**
     *
     * @type {number}
     * @memberof DatasetInfo
     */
    'groupId'?: number;
    /**
     *
     * @type {string}
     * @memberof DatasetInfo
     */
    'categoryTitle'?: string;
    /**
     *
     * @type {number}
     * @memberof DatasetInfo
     */
    'categoryId'?: number;
    /**
     *
     * @type {number}
     * @memberof DatasetInfo
     */
    'decimalPlaces'?: number;
    /**
     *
     * @type {number}
     * @memberof DatasetInfo
     */
    'deviceId'?: number;
    /**
     *
     * @type {string}
     * @memberof DatasetInfo
     */
    'boundToId'?: string;
    /**
     *
     * @type {Set<string>}
     * @memberof DatasetInfo
     */
    'tags'?: Set<string>;
    /**
     *
     * @type {boolean}
     * @memberof DatasetInfo
     */
    'isProxied'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof DatasetInfo
     */
    'isArchived'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof DatasetInfo
     */
    'deleted'?: boolean;
    /**
     *
     * @type {number}
     * @memberof DatasetInfo
     */
    'stringValueMapper'?: number;
}


/**
 *
 * @export
 * @interface DatasetMeta
 */
export interface DatasetMeta {
    /**
     *
     * @type {number}
     * @memberof DatasetMeta
     */
    'maxBound'?: number;
    /**
     *
     * @type {number}
     * @memberof DatasetMeta
     */
    'minBound'?: number;
    /**
     *
     * @type {number}
     * @memberof DatasetMeta
     */
    'decimalPlaces'?: number;
    /**
     *
     * @type {string}
     * @memberof DatasetMeta
     */
    'timeFormat'?: string;
}
/**
 *
 * @export
 * @interface DatasetRequestFilter
 */
export interface DatasetRequestFilter {
    /**
     *
     * @type {Array<string>}
     * @memberof DatasetRequestFilter
     */
    'identifiers'?: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const DatasetType = {
    Hourly: 'HOURLY',
    Daily: 'DAILY',
    Monthly: 'MONTHLY',
    Weekly: 'WEEKLY',
    Seconds: 'SECONDS',
    Minutes: 'MINUTES',
    Arbitrary: 'ARBITRARY',
    ArbitraryMinutes: 'ARBITRARY_MINUTES',
    ArbitrarySeconds: 'ARBITRARY_SECONDS'
} as const;

export type DatasetType = typeof DatasetType[keyof typeof DatasetType];


/**
 *
 * @export
 * @interface DatasetValue
 */
export interface DatasetValue {
    /**
     *
     * @type {string}
     * @memberof DatasetValue
     */
    'time'?: string;
    /**
     *
     * @type {number}
     * @memberof DatasetValue
     */
    'value'?: number;
}
/**
 *
 * @export
 * @interface DatasetValuesDTO
 */
export interface DatasetValuesDTO {
    /**
     *
     * @type {number}
     * @memberof DatasetValuesDTO
     */
    'datasetId'?: number;
    /**
     *
     * @type {Array<DatasetValue>}
     * @memberof DatasetValuesDTO
     */
    'values'?: Array<DatasetValue>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const DayOfWeek = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];


/**
 *
 * @export
 * @interface DeduplicationConfig
 */
export interface DeduplicationConfig {
    /**
     *
     * @type {string}
     * @memberof DeduplicationConfig
     */
    'comment'?: string;
    /**
     *
     * @type {boolean}
     * @memberof DeduplicationConfig
     */
    'enabled'?: boolean;
    /**
     *
     * @type {string}
     * @memberof DeduplicationConfig
     */
    'sendWithNoChangeTimeout'?: string;
    /**
     *
     * @type {number}
     * @memberof DeduplicationConfig
     */
    'epsilon'?: number;
}
/**
 *
 * @export
 * @interface EntryBatchModifyRequest
 */
export interface EntryBatchModifyRequest {
    /**
     *
     * @type {string}
     * @memberof EntryBatchModifyRequest
     */
    'templateRef'?: string;
    /**
     *
     * @type {Array<ProductEntryData>}
     * @memberof EntryBatchModifyRequest
     */
    'entryData'?: Array<ProductEntryData>;
}
/**
 *
 * @export
 * @interface EntryParameters
 */
export interface EntryParameters {
    /**
     *
     * @type {Array<ParameterSection>}
     * @memberof EntryParameters
     */
    'sections'?: Array<ParameterSection>;
}
/**
 *
 * @export
 * @interface ForeignProductEntryKey
 */
export interface ForeignProductEntryKey {
    /**
     *
     * @type {ObjectId}
     * @memberof ForeignProductEntryKey
     */
    'objectId'?: ObjectId;
    /**
     *
     * @type {string}
     * @memberof ForeignProductEntryKey
     */
    'template'?: string;
    /**
     *
     * @type {string}
     * @memberof ForeignProductEntryKey
     */
    'represantationString'?: string;
    /**
     *
     * @type {string}
     * @memberof ForeignProductEntryKey
     */
    'represantationStringSafe'?: string;
}
/**
 *
 * @export
 * @interface GlobalDeduplicationConfig
 */
export interface GlobalDeduplicationConfig {
    /**
     *
     * @type {MeterFilterConfig}
     * @memberof GlobalDeduplicationConfig
     */
    'meterFilterConfig'?: MeterFilterConfig;
    /**
     *
     * @type {DeduplicationConfig}
     * @memberof GlobalDeduplicationConfig
     */
    'deduplicationConfig'?: DeduplicationConfig;
}
/**
 *
 * @export
 * @interface HostInfo
 */
export interface HostInfo {
    /**
     *
     * @type {string}
     * @memberof HostInfo
     */
    'hostname'?: string;
    /**
     *
     * @type {Array<NetworkInterfaceInfo>}
     * @memberof HostInfo
     */
    'ips'?: Array<NetworkInterfaceInfo>;
}
/**
 *
 * @export
 * @interface InetAddress
 */
export interface InetAddress {
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'multicastAddress'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'anyLocalAddress'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'loopbackAddress'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'linkLocalAddress'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'siteLocalAddress'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'MCGlobal'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'MCNodeLocal'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'MCLinkLocal'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'MCSiteLocal'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InetAddress
     */
    'MCOrgLocal'?: boolean;
    /**
     *
     * @type {string}
     * @memberof InetAddress
     */
    'hostName'?: string;
    /**
     *
     * @type {File}
     * @memberof InetAddress
     */
    'address'?: File;
    /**
     *
     * @type {string}
     * @memberof InetAddress
     */
    'hostAddress'?: string;
}
/**
 *
 * @export
 * @interface InstantDoubleValue
 */
export interface InstantDoubleValue {
    /**
     *
     * @type {string}
     * @memberof InstantDoubleValue
     */
    'key'?: string;
    /**
     *
     * @type {number}
     * @memberof InstantDoubleValue
     */
    'value'?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const LogLevel = {
    Off: 'OFF',
    Severe: 'SEVERE',
    Warning: 'WARNING',
    Info: 'INFO',
    Config: 'CONFIG',
    Fine: 'FINE',
    Finer: 'FINER',
    Finest: 'FINEST',
    All: 'ALL'
} as const;

export type LogLevel = typeof LogLevel[keyof typeof LogLevel];


/**
 *
 * @export
 * @interface LogMessage
 */
export interface LogMessage {
    /**
     *
     * @type {string}
     * @memberof LogMessage
     */
    'timestamp'?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessage
     */
    'loggerName'?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessage
     */
    'className'?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessage
     */
    'methodName'?: string;
    /**
     *
     * @type {number}
     * @memberof LogMessage
     */
    'levelInt'?: number;
    /**
     *
     * @type {string}
     * @memberof LogMessage
     */
    'level'?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessage
     */
    'message'?: string;
    /**
     *
     * @type {boolean}
     * @memberof LogMessage
     */
    'hasException'?: boolean;
    /**
     *
     * @type {string}
     * @memberof LogMessage
     */
    'exceptionType'?: string;
}
/**
 *
 * @export
 * @interface LogRequest
 */
export interface LogRequest {
    /**
     *
     * @type {string}
     * @memberof LogRequest
     */
    'from'?: string;
    /**
     *
     * @type {string}
     * @memberof LogRequest
     */
    'to'?: string;
    /**
     *
     * @type {string}
     * @memberof LogRequest
     */
    'duration'?: string;
    /**
     *
     * @type {number}
     * @memberof LogRequest
     */
    'limit'?: number;
    /**
     *
     * @type {LogLevel}
     * @memberof LogRequest
     */
    'minLevel'?: LogLevel;
    /**
     *
     * @type {boolean}
     * @memberof LogRequest
     */
    'requireException'?: boolean;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof LogRequest
     */
    'likeRequests'?: { [key: string]: string; };
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof LogRequest
     */
    'equalRequests'?: { [key: string]: string; };
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof LogRequest
     */
    'regexRequests'?: { [key: string]: string; };
}


/**
 *
 * @export
 * @interface Measurement
 */
export interface Measurement {
    /**
     *
     * @type {string}
     * @memberof Measurement
     */
    'meterId'?: string;
    /**
     *
     * @type {number}
     * @memberof Measurement
     */
    'timeStart'?: number;
    /**
     *
     * @type {number}
     * @memberof Measurement
     */
    'value'?: number;
    /**
     *
     * @type {string}
     * @memberof Measurement
     */
    'unit'?: string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof Measurement
     */
    'meta'?: { [key: string]: string; };
}
/**
 *
 * @export
 * @interface MeasurementRequest
 */
export interface MeasurementRequest {
    /**
     *
     * @type {Array<string>}
     * @memberof MeasurementRequest
     */
    'meters'?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof MeasurementRequest
     */
    'from'?: string;
    /**
     *
     * @type {string}
     * @memberof MeasurementRequest
     */
    'to'?: string;
}
/**
 *
 * @export
 * @interface MeterFilterConfig
 */
export interface MeterFilterConfig {
    /**
     *
     * @type {string}
     * @memberof MeterFilterConfig
     */
    'comment'?: string;
    /**
     *
     * @type {boolean}
     * @memberof MeterFilterConfig
     */
    'useRegex'?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof MeterFilterConfig
     */
    'meters'?: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const Month = {
    January: 'JANUARY',
    February: 'FEBRUARY',
    March: 'MARCH',
    April: 'APRIL',
    May: 'MAY',
    June: 'JUNE',
    July: 'JULY',
    August: 'AUGUST',
    September: 'SEPTEMBER',
    October: 'OCTOBER',
    November: 'NOVEMBER',
    December: 'DECEMBER'
} as const;

export type Month = typeof Month[keyof typeof Month];


/**
 *
 * @export
 * @interface MultiForeignProductEntryKey
 */
export interface MultiForeignProductEntryKey {
    /**
     *
     * @type {Array<ObjectId>}
     * @memberof MultiForeignProductEntryKey
     */
    'objectIds'?: Array<ObjectId>;
    /**
     *
     * @type {string}
     * @memberof MultiForeignProductEntryKey
     */
    'template'?: string;
    /**
     *
     * @type {string}
     * @memberof MultiForeignProductEntryKey
     */
    'represantationString'?: string;
    /**
     *
     * @type {string}
     * @memberof MultiForeignProductEntryKey
     */
    'represantationStringSafe'?: string;
}
/**
 *
 * @export
 * @interface NetworkInterfaceInfo
 */
export interface NetworkInterfaceInfo {
    /**
     *
     * @type {string}
     * @memberof NetworkInterfaceInfo
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof NetworkInterfaceInfo
     */
    'internalName'?: string;
    /**
     *
     * @type {string}
     * @memberof NetworkInterfaceInfo
     */
    'mac'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof NetworkInterfaceInfo
     */
    'ips'?: Array<string>;
}
/**
 *
 * @export
 * @interface OSInfo
 */
export interface OSInfo {
    /**
     *
     * @type {string}
     * @memberof OSInfo
     */
    'osInfo'?: string;
    /**
     *
     * @type {number}
     * @memberof OSInfo
     */
    'availableProcessors'?: number;
    /**
     *
     * @type {string}
     * @memberof OSInfo
     */
    'retrievalTimestamp'?: string;
}
/**
 *
 * @export
 * @interface ObjectId
 */
export interface ObjectId {
    /**
     *
     * @type {string}
     * @memberof ObjectId
     */
    'value'?: string;
}
/**
 *
 * @export
 * @interface OpcUaCertificateDTO
 */
export interface OpcUaCertificateDTO {
    /**
     *
     * @type {string}
     * @memberof OpcUaCertificateDTO
     */
    'thumbprint'?: string;
    /**
     *
     * @type {string}
     * @memberof OpcUaCertificateDTO
     */
    'kind'?: string;
    /**
     *
     * @type {string}
     * @memberof OpcUaCertificateDTO
     */
    'subject'?: string;
    /**
     *
     * @type {string}
     * @memberof OpcUaCertificateDTO
     */
    'username'?: string;
    /**
     *
     * @type {boolean}
     * @memberof OpcUaCertificateDTO
     */
    'enabled'?: boolean;
    /**
     *
     * @type {string}
     * @memberof OpcUaCertificateDTO
     */
    'createdAt'?: string;
}
/**
 *
 * @export
 * @interface OpcUaUserDTO
 */
export interface OpcUaUserDTO {
    /**
     *
     * @type {string}
     * @memberof OpcUaUserDTO
     */
    'username'?: string;
    /**
     *
     * @type {boolean}
     * @memberof OpcUaUserDTO
     */
    'enabled'?: boolean;
    /**
     *
     * @type {string}
     * @memberof OpcUaUserDTO
     */
    'createdAt'?: string;
}
/**
 *
 * @export
 * @interface OpcUaUserRequest
 */
export interface OpcUaUserRequest {
    /**
     *
     * @type {string}
     * @memberof OpcUaUserRequest
     */
    'password'?: string;
    /**
     *
     * @type {boolean}
     * @memberof OpcUaUserRequest
     */
    'enabled'?: boolean;
}
/**
 *
 * @export
 * @interface OpcUaX509UserRequest
 */
export interface OpcUaX509UserRequest {
    /**
     *
     * @type {string}
     * @memberof OpcUaX509UserRequest
     */
    'username'?: string;
    /**
     *
     * @type {string}
     * @memberof OpcUaX509UserRequest
     */
    'commonName'?: string;
    /**
     *
     * @type {number}
     * @memberof OpcUaX509UserRequest
     */
    'validityDays'?: number;
}
/**
 *
 * @export
 * @interface Options
 */
export interface Options {
    /**
     *
     * @type {string}
     * @memberof Options
     */
    'defaultUnit'?: string;
}
/**
 *
 * @export
 * @interface PaginatedResultListProductEntryDTO
 */
export interface PaginatedResultListProductEntryDTO {
    /**
     *
     * @type {Array<ProductEntryDTO>}
     * @memberof PaginatedResultListProductEntryDTO
     */
    'result'?: Array<ProductEntryDTO>;
    /**
     *
     * @type {number}
     * @memberof PaginatedResultListProductEntryDTO
     */
    'totalCount'?: number;
    /**
     *
     * @type {number}
     * @memberof PaginatedResultListProductEntryDTO
     */
    'page'?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ParamType = {
    Text: 'TEXT',
    Number: 'NUMBER',
    Link: 'LINK',
    Date: 'DATE',
    File: 'FILE',
    Image: 'IMAGE',
    MomentNumber: 'MOMENT_NUMBER'
} as const;

export type ParamType = typeof ParamType[keyof typeof ParamType];


/**
 *
 * @export
 * @interface ParameterDefinition
 */
export interface ParameterDefinition {
    /**
     *
     * @type {string}
     * @memberof ParameterDefinition
     */
    'name'?: string;
    /**
     *
     * @type {ParamType}
     * @memberof ParameterDefinition
     */
    'type'?: ParamType;
    /**
     *
     * @type {Options}
     * @memberof ParameterDefinition
     */
    'options'?: Options;
}


/**
 *
 * @export
 * @interface ParameterSection
 */
export interface ParameterSection {
    /**
     *
     * @type {string}
     * @memberof ParameterSection
     */
    'sectionTitle'?: string;
    /**
     *
     * @type {Array<ParameterSectionParametersInner>}
     * @memberof ParameterSection
     */
    'parameters'?: Array<ParameterSectionParametersInner>;
    /**
     *
     * @type {ParameterSectionTemplate}
     * @memberof ParameterSection
     */
    'template'?: ParameterSectionTemplate;
}
/**
 *
 * @export
 * @interface ParameterSectionParametersInner
 */
export interface ParameterSectionParametersInner {
    /**
     *
     * @type {ParamType}
     * @memberof ParameterSectionParametersInner
     */
    'type'?: ParamType;
    /**
     *
     * @type {string}
     * @memberof ParameterSectionParametersInner
     */
    'param'?: string;
    /**
     *
     * @type {any}
     * @memberof ParameterSectionParametersInner
     */
    'value'?: any;
    /**
     *
     * @type {ParameterDefinition}
     * @memberof ParameterSectionParametersInner
     */
    'definition'?: ParameterDefinition;
    /**
     *
     * @type {boolean}
     * @memberof ParameterSectionParametersInner
     */
    'shouldRender'?: boolean;
}


/**
 *
 * @export
 * @interface ParameterSectionTemplate
 */
export interface ParameterSectionTemplate {
    /**
     *
     * @type {string}
     * @memberof ParameterSectionTemplate
     */
    'sectionTitle'?: string;
    /**
     *
     * @type {Array<ParameterDefinition>}
     * @memberof ParameterSectionTemplate
     */
    'parameters'?: Array<ParameterDefinition>;
    /**
     *
     * @type {ParameterSection}
     * @memberof ParameterSectionTemplate
     */
    'parameterSection'?: ParameterSection;
}
/**
 *
 * @export
 * @interface PingParameters
 */
export interface PingParameters {
    /**
     *
     * @type {InetAddress}
     * @memberof PingParameters
     */
    'address'?: InetAddress;
    /**
     *
     * @type {number}
     * @memberof PingParameters
     */
    'count'?: number;
    /**
     *
     * @type {boolean}
     * @memberof PingParameters
     */
    'forceIPV4'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PingParameters
     */
    'forceIPV6'?: boolean;
    /**
     *
     * @type {number}
     * @memberof PingParameters
     */
    'ttl'?: number;
    /**
     *
     * @type {number}
     * @memberof PingParameters
     */
    'timeout'?: number;
}
/**
 *
 * @export
 * @interface PostProcessorConfigDTO
 */
export interface PostProcessorConfigDTO {
    /**
     *
     * @type {PostProcessorType}
     * @memberof PostProcessorConfigDTO
     */
    'postProcessorType'?: PostProcessorType;
    /**
     *
     * @type {Set<string>}
     * @memberof PostProcessorConfigDTO
     */
    'readers'?: Set<string>;
    /**
     *
     * @type {PostProcessorPriority}
     * @memberof PostProcessorConfigDTO
     */
    'priority'?: PostProcessorPriority;
    /**
     *
     * @type {object}
     * @memberof PostProcessorConfigDTO
     */
    'config'?: object;
}


/**
 *
 * @export
 * @interface PostProcessorDescription
 */
export interface PostProcessorDescription {
    /**
     *
     * @type {string}
     * @memberof PostProcessorDescription
     */
    'implementationKey'?: string;
    /**
     *
     * @type {string}
     * @memberof PostProcessorDescription
     */
    'name'?: string;
    /**
     *
     * @type {boolean}
     * @memberof PostProcessorDescription
     */
    'deprecated'?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const PostProcessorPriority = {
    Before: 'BEFORE',
    After: 'AFTER'
} as const;

export type PostProcessorPriority = typeof PostProcessorPriority[keyof typeof PostProcessorPriority];


/**
 *
 * @export
 * @enum {string}
 */

export const PostProcessorType = {
    Measurements: 'MEASUREMENTS',
    Products: 'PRODUCTS'
} as const;

export type PostProcessorType = typeof PostProcessorType[keyof typeof PostProcessorType];


/**
 *
 * @export
 * @interface ProductEntries
 */
export interface ProductEntries {
    /**
     *
     * @type {string}
     * @memberof ProductEntries
     */
    'templateRefName'?: string;
    /**
     *
     * @type {boolean}
     * @memberof ProductEntries
     */
    'overwriteOnSameKey'?: boolean;
    /**
     *
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ProductEntries
     */
    'entries'?: Array<{ [key: string]: any; }>;
}
/**
 *
 * @export
 * @interface ProductEntriesUpdateModel
 */
export interface ProductEntriesUpdateModel {
    /**
     *
     * @type {string}
     * @memberof ProductEntriesUpdateModel
     */
    'templateRefName'?: string;
    /**
     *
     * @type {boolean}
     * @memberof ProductEntriesUpdateModel
     */
    'overwriteOnSameKey'?: boolean;
    /**
     *
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ProductEntriesUpdateModel
     */
    'entries'?: Array<{ [key: string]: any; }>;
}
/**
 *
 * @export
 * @interface ProductEntryDTO
 */
export interface ProductEntryDTO {
    /**
     *
     * @type {ObjectId}
     * @memberof ProductEntryDTO
     */
    'id'?: ObjectId;
    /**
     *
     * @type {string}
     * @memberof ProductEntryDTO
     */
    'template'?: string;
    /**
     *
     * @type {{ [key: string]: ProductEntryData; }}
     * @memberof ProductEntryDTO
     */
    'entries'?: { [key: string]: ProductEntryData; };
    /**
     *
     * @type {string}
     * @memberof ProductEntryDTO
     */
    'dateCreated'?: string;
    /**
     *
     * @type {string}
     * @memberof ProductEntryDTO
     */
    'dateModified'?: string;
    /**
     *
     * @type {string}
     * @memberof ProductEntryDTO
     */
    'keyValue'?: string;
    /**
     *
     * @type {string}
     * @memberof ProductEntryDTO
     */
    'metaKeyValue'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof ProductEntryDTO
     */
    'entryKeyList'?: Array<string>;
    /**
     *
     * @type {Array<ProductEntryData>}
     * @memberof ProductEntryDTO
     */
    'dataList'?: Array<ProductEntryData>;
    /**
     *
     * @type {string}
     * @memberof ProductEntryDTO
     */
    'stringRepresentation'?: string;
    /**
     *
     * @type {Array<any>}
     * @memberof ProductEntryDTO
     */
    'errors'?: Array<any>;
}
/**
 *
 * @export
 * @interface ProductEntryData
 */
export interface ProductEntryData {
    /**
     *
     * @type {string}
     * @memberof ProductEntryData
     */
    'referenceName'?: string;
    /**
     *
     * @type {AttributeType}
     * @memberof ProductEntryData
     */
    'type'?: AttributeType;
    /**
     *
     * @type {any}
     * @memberof ProductEntryData
     */
    'value'?: any;
    /**
     *
     * @type {boolean}
     * @memberof ProductEntryData
     */
    'null'?: boolean;
    /**
     *
     * @type {string}
     * @memberof ProductEntryData
     */
    'strValue'?: string;
    /**
     *
     * @type {EntryParameters}
     * @memberof ProductEntryData
     */
    'entryParameters'?: EntryParameters;
    /**
     *
     * @type {number}
     * @memberof ProductEntryData
     */
    'longValue'?: number;
    /**
     *
     * @type {number}
     * @memberof ProductEntryData
     */
    'decimalValue'?: number;
    /**
     *
     * @type {string}
     * @memberof ProductEntryData
     */
    'instantValue'?: string;
    /**
     *
     * @type {string}
     * @memberof ProductEntryData
     */
    'datetimeValue'?: string;
    /**
     *
     * @type {string}
     * @memberof ProductEntryData
     */
    'timeValue'?: string;
    /**
     *
     * @type {Timespan}
     * @memberof ProductEntryData
     */
    'timespanValue'?: Timespan;
    /**
     *
     * @type {ForeignProductEntryKey}
     * @memberof ProductEntryData
     */
    'foreignEntryValue'?: ForeignProductEntryKey;
    /**
     *
     * @type {MultiForeignProductEntryKey}
     * @memberof ProductEntryData
     */
    'multiForeignEntryValue'?: MultiForeignProductEntryKey;
    /**
     *
     * @type {UserSignature}
     * @memberof ProductEntryData
     */
    'userSignature'?: UserSignature;
    /**
     *
     * @type {string}
     * @memberof ProductEntryData
     */
    'timespanStr'?: string;
    /**
     *
     * @type {number}
     * @memberof ProductEntryData
     */
    'asBigDecimal'?: number;
}


/**
 *
 * @export
 * @interface ProductItem
 */
export interface ProductItem {
    /**
     *
     * @type {ObjectId}
     * @memberof ProductItem
     */
    'objectId'?: ObjectId;
    /**
     *
     * @type {string}
     * @memberof ProductItem
     */
    'template'?: string;
    /**
     *
     * @type {string}
     * @memberof ProductItem
     */
    'timestamp'?: string;
    /**
     *
     * @type {string}
     * @memberof ProductItem
     */
    'modified'?: string;
    /**
     *
     * @type {{ [key: string]: ProductEntryData; }}
     * @memberof ProductItem
     */
    'values'?: { [key: string]: ProductEntryData; };
}
/**
 *
 * @export
 * @interface ProductRequest
 */
export interface ProductRequest {
    /**
     *
     * @type {Array<string>}
     * @memberof ProductRequest
     */
    'templates'?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof ProductRequest
     */
    'from'?: string;
    /**
     *
     * @type {string}
     * @memberof ProductRequest
     */
    'to'?: string;
}
/**
 *
 * @export
 * @interface ProductTemplateInfoDTO
 */
export interface ProductTemplateInfoDTO {
    /**
     *
     * @type {number}
     * @memberof ProductTemplateInfoDTO
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof ProductTemplateInfoDTO
     */
    'refName'?: string;
    /**
     *
     * @type {string}
     * @memberof ProductTemplateInfoDTO
     */
    'displayName'?: string;
    /**
     *
     * @type {number}
     * @memberof ProductTemplateInfoDTO
     */
    'companyId'?: number;
    /**
     *
     * @type {string}
     * @memberof ProductTemplateInfoDTO
     */
    'companyRef'?: string;
}
/**
 *
 * @export
 * @interface ProtocolDescription
 */
export interface ProtocolDescription {
    /**
     *
     * @type {string}
     * @memberof ProtocolDescription
     */
    'implementationKey'?: string;
    /**
     *
     * @type {ProtocolType}
     * @memberof ProtocolDescription
     */
    'protocolType'?: ProtocolType;
    /**
     *
     * @type {string}
     * @memberof ProtocolDescription
     */
    'name'?: string;
    /**
     *
     * @type {boolean}
     * @memberof ProtocolDescription
     */
    'deprecated'?: boolean;
}


/**
 *
 * @export
 * @enum {string}
 */

export const ProtocolType = {
    Measurements: 'MEASUREMENTS',
    ProductItems: 'PRODUCT_ITEMS'
} as const;

export type ProtocolType = typeof ProtocolType[keyof typeof ProtocolType];


/**
 *
 * @export
 * @interface PythonProductEntry
 */
export interface PythonProductEntry {
    /**
     *
     * @type {ObjectId}
     * @memberof PythonProductEntry
     */
    'dbId'?: ObjectId;
    /**
     *
     * @type {Array<ProductEntryData>}
     * @memberof PythonProductEntry
     */
    'entryData'?: Array<ProductEntryData>;
}
/**
 *
 * @export
 * @interface PythonProductTemplateData
 */
export interface PythonProductTemplateData {
    /**
     *
     * @type {number}
     * @memberof PythonProductTemplateData
     */
    'templateDbId'?: number;
    /**
     *
     * @type {string}
     * @memberof PythonProductTemplateData
     */
    'safeName'?: string;
    /**
     *
     * @type {string}
     * @memberof PythonProductTemplateData
     */
    'keyReference'?: string;
    /**
     *
     * @type {string}
     * @memberof PythonProductTemplateData
     */
    'metaKeyReference'?: string;
    /**
     *
     * @type {Array<PythonProductEntry>}
     * @memberof PythonProductTemplateData
     */
    'entries'?: Array<PythonProductEntry>;
    /**
     *
     * @type {Array<string>}
     * @memberof PythonProductTemplateData
     */
    'deletedEntriesIds'?: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ReaderType = {
    Measurements: 'MEASUREMENTS',
    Products: 'PRODUCTS',
    All: 'ALL'
} as const;

export type ReaderType = typeof ReaderType[keyof typeof ReaderType];


/**
 *
 * @export
 * @interface RemoteDatasetDTO
 */
export interface RemoteDatasetDTO {
    /**
     *
     * @type {number}
     * @memberof RemoteDatasetDTO
     */
    'id'?: number;
    /**
     *
     * @type {number}
     * @memberof RemoteDatasetDTO
     */
    'categoryId'?: number;
    /**
     *
     * @type {number}
     * @memberof RemoteDatasetDTO
     */
    'companyId'?: number;
    /**
     *
     * @type {number}
     * @memberof RemoteDatasetDTO
     */
    'groupId'?: number;
    /**
     *
     * @type {string}
     * @memberof RemoteDatasetDTO
     */
    'clientId'?: string;
    /**
     *
     * @type {number}
     * @memberof RemoteDatasetDTO
     */
    'measurementDeviceId'?: number;
    /**
     *
     * @type {string}
     * @memberof RemoteDatasetDTO
     */
    'title'?: string;
    /**
     *
     * @type {string}
     * @memberof RemoteDatasetDTO
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof RemoteDatasetDTO
     */
    'unit'?: string;
    /**
     *
     * @type {DatasetType}
     * @memberof RemoteDatasetDTO
     */
    'datasetType': DatasetType;
    /**
     *
     * @type {DatasetDataType}
     * @memberof RemoteDatasetDTO
     */
    'datasetDataType': DatasetDataType;
    /**
     *
     * @type {DatasetAccessType}
     * @memberof RemoteDatasetDTO
     */
    'datasetAccessType': DatasetAccessType;
    /**
     *
     * @type {Set<string>}
     * @memberof RemoteDatasetDTO
     */
    'tags': Set<string>;
    /**
     *
     * @type {DatasetMeta}
     * @memberof RemoteDatasetDTO
     */
    'datasetMeta': DatasetMeta;
    /**
     *
     * @type {boolean}
     * @memberof RemoteDatasetDTO
     */
    'hidden'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof RemoteDatasetDTO
     */
    'deleted'?: boolean;
    /**
     *
     * @type {number}
     * @memberof RemoteDatasetDTO
     */
    'createTime'?: number;
    /**
     *
     * @type {number}
     * @memberof RemoteDatasetDTO
     */
    'editTime'?: number;
    /**
     *
     * @type {number}
     * @memberof RemoteDatasetDTO
     */
    'retentionPolicyId'?: number;
    /**
     *
     * @type {number}
     * @memberof RemoteDatasetDTO
     */
    'valueMapperId'?: number;
}


/**
 *
 * @export
 * @interface TagMapperTestRequest
 */
export interface TagMapperTestRequest {
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof TagMapperTestRequest
     */
    'mapperConfig': { [key: string]: string; };
    /**
     *
     * @type {Array<string>}
     * @memberof TagMapperTestRequest
     */
    'tags': Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const TimeDefinition = {
    Utc: 'UTC',
    Wall: 'WALL',
    Standard: 'STANDARD'
} as const;

export type TimeDefinition = typeof TimeDefinition[keyof typeof TimeDefinition];


/**
 *
 * @export
 * @interface TimeInfo
 */
export interface TimeInfo {
    /**
     *
     * @type {ZoneId}
     * @memberof TimeInfo
     */
    'timeZone'?: ZoneId;
    /**
     *
     * @type {string}
     * @memberof TimeInfo
     */
    'utcTime'?: string;
    /**
     *
     * @type {string}
     * @memberof TimeInfo
     */
    'offsetTime'?: string;
    /**
     *
     * @type {string}
     * @memberof TimeInfo
     */
    'zonedTime'?: string;
}
/**
 *
 * @export
 * @interface TimeMomentValue
 */
export interface TimeMomentValue {
    /**
     *
     * @type {string}
     * @memberof TimeMomentValue
     */
    'key'?: string;
    /**
     *
     * @type {number}
     * @memberof TimeMomentValue
     */
    'value'?: number;
}
/**
 *
 * @export
 * @interface Timespan
 */
export interface Timespan {
    /**
     *
     * @type {number}
     * @memberof Timespan
     */
    'days'?: number;
    /**
     *
     * @type {number}
     * @memberof Timespan
     */
    'hours'?: number;
    /**
     *
     * @type {number}
     * @memberof Timespan
     */
    'minutes'?: number;
    /**
     *
     * @type {number}
     * @memberof Timespan
     */
    'seconds'?: number;
    /**
     *
     * @type {string}
     * @memberof Timespan
     */
    'hoursMinutes'?: string;
    /**
     *
     * @type {number}
     * @memberof Timespan
     */
    'totalSeconds'?: number;
    /**
     *
     * @type {number}
     * @memberof Timespan
     */
    'totalHours'?: number;
}
/**
 *
 * @export
 * @interface TracerouteParameters
 */
export interface TracerouteParameters {
    /**
     *
     * @type {InetAddress}
     * @memberof TracerouteParameters
     */
    'address'?: InetAddress;
    /**
     *
     * @type {number}
     * @memberof TracerouteParameters
     */
    'maxHops'?: number;
    /**
     *
     * @type {number}
     * @memberof TracerouteParameters
     */
    'timeout'?: number;
    /**
     *
     * @type {boolean}
     * @memberof TracerouteParameters
     */
    'forceIPV4'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof TracerouteParameters
     */
    'forceIPV6'?: boolean;
}
/**
 *
 * @export
 * @interface UpdateDatasetData
 */
export interface UpdateDatasetData {
    /**
     * Dataset identifier in format \'id:class\'
     * @type {string}
     * @memberof UpdateDatasetData
     */
    'identifier'?: string;
    /**
     *
     * @type {{ [key: string]: number; }}
     * @memberof UpdateDatasetData
     */
    'values'?: { [key: string]: number; };
}
/**
 *
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     *
     * @type {string}
     * @memberof UserInfo
     */
    'username'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof UserInfo
     */
    'userCompanies'?: Array<string>;
}
/**
 *
 * @export
 * @interface UserSignature
 */
export interface UserSignature {
    /**
     *
     * @type {number}
     * @memberof UserSignature
     */
    'id'?: number;
    /**
     *
     * @type {string}
     * @memberof UserSignature
     */
    'display'?: string;
    /**
     *
     * @type {boolean}
     * @memberof UserSignature
     */
    'signed'?: boolean;
    /**
     *
     * @type {string}
     * @memberof UserSignature
     */
    'signedAt'?: string;
}
/**
 *
 * @export
 * @interface VersionInfo
 */
export interface VersionInfo {
    /**
     *
     * @type {string}
     * @memberof VersionInfo
     */
    'version'?: string;
    /**
     *
     * @type {string}
     * @memberof VersionInfo
     */
    'buildTime'?: string;
    /**
     *
     * @type {string}
     * @memberof VersionInfo
     */
    'buildId'?: string;
    /**
     *
     * @type {OSInfo}
     * @memberof VersionInfo
     */
    'osInfo'?: OSInfo;
    /**
     *
     * @type {HostInfo}
     * @memberof VersionInfo
     */
    'hostInfo'?: HostInfo;
}
/**
 *
 * @export
 * @interface ZoneId
 */
export interface ZoneId {
    /**
     *
     * @type {string}
     * @memberof ZoneId
     */
    'id'?: string;
    /**
     *
     * @type {ZoneRules}
     * @memberof ZoneId
     */
    'rules'?: ZoneRules;
}
/**
 *
 * @export
 * @interface ZoneOffset
 */
export interface ZoneOffset {
    /**
     *
     * @type {number}
     * @memberof ZoneOffset
     */
    'totalSeconds'?: number;
}
/**
 *
 * @export
 * @interface ZoneOffsetTransition
 */
export interface ZoneOffsetTransition {
    /**
     *
     * @type {number}
     * @memberof ZoneOffsetTransition
     */
    'epochSecond'?: number;
    /**
     *
     * @type {string}
     * @memberof ZoneOffsetTransition
     */
    'transition'?: string;
    /**
     *
     * @type {ZoneOffset}
     * @memberof ZoneOffsetTransition
     */
    'offsetBefore'?: ZoneOffset;
    /**
     *
     * @type {ZoneOffset}
     * @memberof ZoneOffsetTransition
     */
    'offsetAfter'?: ZoneOffset;
    /**
     *
     * @type {string}
     * @memberof ZoneOffsetTransition
     */
    'instant'?: string;
    /**
     *
     * @type {string}
     * @memberof ZoneOffsetTransition
     */
    'dateTimeBefore'?: string;
    /**
     *
     * @type {string}
     * @memberof ZoneOffsetTransition
     */
    'dateTimeAfter'?: string;
    /**
     *
     * @type {string}
     * @memberof ZoneOffsetTransition
     */
    'duration'?: string;
    /**
     *
     * @type {number}
     * @memberof ZoneOffsetTransition
     */
    'durationSeconds'?: number;
    /**
     *
     * @type {boolean}
     * @memberof ZoneOffsetTransition
     */
    'gap'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ZoneOffsetTransition
     */
    'overlap'?: boolean;
    /**
     *
     * @type {Array<ZoneOffset>}
     * @memberof ZoneOffsetTransition
     */
    'validOffsets'?: Array<ZoneOffset>;
}
/**
 *
 * @export
 * @interface ZoneOffsetTransitionRule
 */
export interface ZoneOffsetTransitionRule {
    /**
     *
     * @type {Month}
     * @memberof ZoneOffsetTransitionRule
     */
    'month'?: Month;
    /**
     *
     * @type {number}
     * @memberof ZoneOffsetTransitionRule
     */
    'dom'?: number;
    /**
     *
     * @type {DayOfWeek}
     * @memberof ZoneOffsetTransitionRule
     */
    'dow'?: DayOfWeek;
    /**
     *
     * @type {string}
     * @memberof ZoneOffsetTransitionRule
     */
    'time'?: string;
    /**
     *
     * @type {boolean}
     * @memberof ZoneOffsetTransitionRule
     */
    'timeEndOfDay'?: boolean;
    /**
     *
     * @type {TimeDefinition}
     * @memberof ZoneOffsetTransitionRule
     */
    'timeDefinition'?: TimeDefinition;
    /**
     *
     * @type {ZoneOffset}
     * @memberof ZoneOffsetTransitionRule
     */
    'standardOffset'?: ZoneOffset;
    /**
     *
     * @type {ZoneOffset}
     * @memberof ZoneOffsetTransitionRule
     */
    'offsetBefore'?: ZoneOffset;
    /**
     *
     * @type {ZoneOffset}
     * @memberof ZoneOffsetTransitionRule
     */
    'offsetAfter'?: ZoneOffset;
    /**
     *
     * @type {number}
     * @memberof ZoneOffsetTransitionRule
     */
    'dayOfMonthIndicator'?: number;
    /**
     *
     * @type {DayOfWeek}
     * @memberof ZoneOffsetTransitionRule
     */
    'dayOfWeek'?: DayOfWeek;
    /**
     *
     * @type {string}
     * @memberof ZoneOffsetTransitionRule
     */
    'localTime'?: string;
    /**
     *
     * @type {boolean}
     * @memberof ZoneOffsetTransitionRule
     */
    'midnightEndOfDay'?: boolean;
}


/**
 *
 * @export
 * @interface ZoneRules
 */
export interface ZoneRules {
    /**
     *
     * @type {Array<number>}
     * @memberof ZoneRules
     */
    'standardTransitions'?: Array<number>;
    /**
     *
     * @type {Array<ZoneOffset>}
     * @memberof ZoneRules
     */
    'standardOffsets'?: Array<ZoneOffset>;
    /**
     *
     * @type {Array<number>}
     * @memberof ZoneRules
     */
    'savingsInstantTransitions'?: Array<number>;
    /**
     *
     * @type {Array<string>}
     * @memberof ZoneRules
     */
    'savingsLocalTransitions'?: Array<string>;
    /**
     *
     * @type {Array<ZoneOffset>}
     * @memberof ZoneRules
     */
    'wallOffsets'?: Array<ZoneOffset>;
    /**
     *
     * @type {Array<ZoneOffsetTransitionRule>}
     * @memberof ZoneRules
     */
    'lastRules'?: Array<ZoneOffsetTransitionRule>;
    /**
     *
     * @type {boolean}
     * @memberof ZoneRules
     */
    'fixedOffset'?: boolean;
    /**
     *
     * @type {Array<ZoneOffsetTransition>}
     * @memberof ZoneRules
     */
    'transitions'?: Array<ZoneOffsetTransition>;
    /**
     *
     * @type {Array<ZoneOffsetTransitionRule>}
     * @memberof ZoneRules
     */
    'transitionRules'?: Array<ZoneOffsetTransitionRule>;
}

/**
 * ActionsApi - axios parameter creator
 * @export
 */
export const ActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Invoke
         * @param {string} aReaderId
         * @param {string} bActionId
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restActionsInvokeAReaderIdBActionIdPost: async (aReaderId: string, bActionId: string, body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aReaderId' is not null or undefined
            assertParamExists('restActionsInvokeAReaderIdBActionIdPost', 'aReaderId', aReaderId)
            // verify required parameter 'bActionId' is not null or undefined
            assertParamExists('restActionsInvokeAReaderIdBActionIdPost', 'bActionId', bActionId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('restActionsInvokeAReaderIdBActionIdPost', 'body', body)
            const localVarPath = `/rest/actions/invoke/{a_readerId}/{b_actionId}`
                .replace(`{${"a_readerId"}}`, encodeURIComponent(String(aReaderId)))
                .replace(`{${"b_actionId"}}`, encodeURIComponent(String(bActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Actions
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restActionsSchemaGet: async (schema: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('restActionsSchemaGet', 'schema', schema)
            const localVarPath = `/rest/actions/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionsApi - functional programming interface
 * @export
 */
export const ActionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Invoke
         * @param {string} aReaderId
         * @param {string} bActionId
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restActionsInvokeAReaderIdBActionIdPost(aReaderId: string, bActionId: string, body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restActionsInvokeAReaderIdBActionIdPost(aReaderId, bActionId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.restActionsInvokeAReaderIdBActionIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Actions
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restActionsSchemaGet(schema: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restActionsSchemaGet(schema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.restActionsSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionsApi - factory interface
 * @export
 */
export const ActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionsApiFp(configuration)
    return {
        /**
         *
         * @summary Invoke
         * @param {string} aReaderId
         * @param {string} bActionId
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restActionsInvokeAReaderIdBActionIdPost(aReaderId: string, bActionId: string, body: any, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.restActionsInvokeAReaderIdBActionIdPost(aReaderId, bActionId, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Actions
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restActionsSchemaGet(schema: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActionDTO>> {
            return localVarFp.restActionsSchemaGet(schema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActionsApi - object-oriented interface
 * @export
 * @class ActionsApi
 * @extends {BaseAPI}
 */
export class ActionsApi extends BaseAPI {
    /**
     *
     * @summary Invoke
     * @param {string} aReaderId
     * @param {string} bActionId
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public restActionsInvokeAReaderIdBActionIdPost(aReaderId: string, bActionId: string, body: any, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).restActionsInvokeAReaderIdBActionIdPost(aReaderId, bActionId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Actions
     * @param {string} schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public restActionsSchemaGet(schema: string, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).restActionsSchemaGet(schema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditLogResourceApi - axios parameter creator
 * @export
 */
export const AuditLogResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get By Actor
         * @param {string} actorId
         * @param {string} actorType
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restLogsAuditActorActorTypeActorIdGet: async (actorId: string, actorType: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actorId' is not null or undefined
            assertParamExists('restLogsAuditActorActorTypeActorIdGet', 'actorId', actorId)
            // verify required parameter 'actorType' is not null or undefined
            assertParamExists('restLogsAuditActorActorTypeActorIdGet', 'actorType', actorType)
            const localVarPath = `/rest/logs/audit/actor/{actorType}/{actorId}`
                .replace(`{${"actorId"}}`, encodeURIComponent(String(actorId)))
                .replace(`{${"actorType"}}`, encodeURIComponent(String(actorType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get By Entity
         * @param {string} entity
         * @param {string} entityId
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restLogsAuditEntityEntityEntityIdGet: async (entity: string, entityId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('restLogsAuditEntityEntityEntityIdGet', 'entity', entity)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('restLogsAuditEntityEntityEntityIdGet', 'entityId', entityId)
            const localVarPath = `/rest/logs/audit/entity/{entity}/{entityId}`
                .replace(`{${"entity"}}`, encodeURIComponent(String(entity)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Query
         * @param {string} [actorId]
         * @param {string} [actorType]
         * @param {string} [domain]
         * @param {string} [entity]
         * @param {string} [entityId]
         * @param {string} [from]
         * @param {number} [limit]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restLogsAuditGet: async (actorId?: string, actorType?: string, domain?: string, entity?: string, entityId?: string, from?: string, limit?: number, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/logs/audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actorId !== undefined) {
                localVarQueryParameter['actorId'] = actorId;
            }

            if (actorType !== undefined) {
                localVarQueryParameter['actorType'] = actorType;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (entity !== undefined) {
                localVarQueryParameter['entity'] = entity;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Query
         * @param {AuditLogQuery} auditLogQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restLogsAuditPost: async (auditLogQuery: AuditLogQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditLogQuery' is not null or undefined
            assertParamExists('restLogsAuditPost', 'auditLogQuery', auditLogQuery)
            const localVarPath = `/rest/logs/audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditLogQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditLogResourceApi - functional programming interface
 * @export
 */
export const AuditLogResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditLogResourceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get By Actor
         * @param {string} actorId
         * @param {string} actorType
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restLogsAuditActorActorTypeActorIdGet(actorId: string, actorType: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityLogEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restLogsAuditActorActorTypeActorIdGet(actorId, actorType, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogResourceApi.restLogsAuditActorActorTypeActorIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get By Entity
         * @param {string} entity
         * @param {string} entityId
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restLogsAuditEntityEntityEntityIdGet(entity: string, entityId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityLogEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restLogsAuditEntityEntityEntityIdGet(entity, entityId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogResourceApi.restLogsAuditEntityEntityEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Query
         * @param {string} [actorId]
         * @param {string} [actorType]
         * @param {string} [domain]
         * @param {string} [entity]
         * @param {string} [entityId]
         * @param {string} [from]
         * @param {number} [limit]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restLogsAuditGet(actorId?: string, actorType?: string, domain?: string, entity?: string, entityId?: string, from?: string, limit?: number, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityLogEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restLogsAuditGet(actorId, actorType, domain, entity, entityId, from, limit, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogResourceApi.restLogsAuditGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Query
         * @param {AuditLogQuery} auditLogQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restLogsAuditPost(auditLogQuery: AuditLogQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityLogEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restLogsAuditPost(auditLogQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogResourceApi.restLogsAuditPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditLogResourceApi - factory interface
 * @export
 */
export const AuditLogResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditLogResourceApiFp(configuration)
    return {
        /**
         *
         * @summary Get By Actor
         * @param {string} actorId
         * @param {string} actorType
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restLogsAuditActorActorTypeActorIdGet(actorId: string, actorType: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityLogEntry>> {
            return localVarFp.restLogsAuditActorActorTypeActorIdGet(actorId, actorType, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get By Entity
         * @param {string} entity
         * @param {string} entityId
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restLogsAuditEntityEntityEntityIdGet(entity: string, entityId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityLogEntry>> {
            return localVarFp.restLogsAuditEntityEntityEntityIdGet(entity, entityId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Query
         * @param {string} [actorId]
         * @param {string} [actorType]
         * @param {string} [domain]
         * @param {string} [entity]
         * @param {string} [entityId]
         * @param {string} [from]
         * @param {number} [limit]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restLogsAuditGet(actorId?: string, actorType?: string, domain?: string, entity?: string, entityId?: string, from?: string, limit?: number, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityLogEntry>> {
            return localVarFp.restLogsAuditGet(actorId, actorType, domain, entity, entityId, from, limit, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Query
         * @param {AuditLogQuery} auditLogQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restLogsAuditPost(auditLogQuery: AuditLogQuery, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityLogEntry>> {
            return localVarFp.restLogsAuditPost(auditLogQuery, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditLogResourceApi - object-oriented interface
 * @export
 * @class AuditLogResourceApi
 * @extends {BaseAPI}
 */
export class AuditLogResourceApi extends BaseAPI {
    /**
     *
     * @summary Get By Actor
     * @param {string} actorId
     * @param {string} actorType
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogResourceApi
     */
    public restLogsAuditActorActorTypeActorIdGet(actorId: string, actorType: string, limit?: number, options?: RawAxiosRequestConfig) {
        return AuditLogResourceApiFp(this.configuration).restLogsAuditActorActorTypeActorIdGet(actorId, actorType, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get By Entity
     * @param {string} entity
     * @param {string} entityId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogResourceApi
     */
    public restLogsAuditEntityEntityEntityIdGet(entity: string, entityId: string, limit?: number, options?: RawAxiosRequestConfig) {
        return AuditLogResourceApiFp(this.configuration).restLogsAuditEntityEntityEntityIdGet(entity, entityId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Query
     * @param {string} [actorId]
     * @param {string} [actorType]
     * @param {string} [domain]
     * @param {string} [entity]
     * @param {string} [entityId]
     * @param {string} [from]
     * @param {number} [limit]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogResourceApi
     */
    public restLogsAuditGet(actorId?: string, actorType?: string, domain?: string, entity?: string, entityId?: string, from?: string, limit?: number, to?: string, options?: RawAxiosRequestConfig) {
        return AuditLogResourceApiFp(this.configuration).restLogsAuditGet(actorId, actorType, domain, entity, entityId, from, limit, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Query
     * @param {AuditLogQuery} auditLogQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogResourceApi
     */
    public restLogsAuditPost(auditLogQuery: AuditLogQuery, options?: RawAxiosRequestConfig) {
        return AuditLogResourceApiFp(this.configuration).restLogsAuditPost(auditLogQuery, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BackupApi - axios parameter creator
 * @export
 */
export const BackupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Backup
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBackup: async (readerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('createBackup', 'readerId', readerId)
            const localVarPath = `/rest/backup/backup/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Remote Backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRemoteBackup: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/backup/createRemoteBackup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Backup
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBackup: async (ids: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteBackup', 'ids', ids)
            const localVarPath = `/rest/backup/backup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Backups
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackups: async (ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/backup/entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Configuration Backup
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationBackup: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getConfigurationBackup', 'id', id)
            const localVarPath = `/rest/backup/backup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore Backup
         * @param {string} readerId
         * @param {number} backupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackup: async (readerId: string, backupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('restoreBackup', 'readerId', readerId)
            // verify required parameter 'backupId' is not null or undefined
            assertParamExists('restoreBackup', 'backupId', backupId)
            const localVarPath = `/rest/backup/restore/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BackupApi - functional programming interface
 * @export
 */
export const BackupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BackupApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Backup
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBackup(readerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBackup(readerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.createBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create Remote Backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRemoteBackup(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRemoteBackup(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.createRemoteBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Backup
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBackup(ids: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBackup(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.deleteBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Backups
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBackups(ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBackups(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.getBackups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Configuration Backup
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurationBackup(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigurationBackup(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.getConfigurationBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore Backup
         * @param {string} readerId
         * @param {number} backupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreBackup(readerId: string, backupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreBackup(readerId, backupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.restoreBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BackupApi - factory interface
 * @export
 */
export const BackupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BackupApiFp(configuration)
    return {
        /**
         *
         * @summary Create Backup
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBackup(readerId: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createBackup(readerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Remote Backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRemoteBackup(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createRemoteBackup(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Backup
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBackup(ids: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBackup(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Backups
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackups(ids?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackupEntry>> {
            return localVarFp.getBackups(ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Configuration Backup
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationBackup(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getConfigurationBackup(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore Backup
         * @param {string} readerId
         * @param {number} backupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackup(readerId: string, backupId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreBackup(readerId, backupId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BackupApi - object-oriented interface
 * @export
 * @class BackupApi
 * @extends {BaseAPI}
 */
export class BackupApi extends BaseAPI {
    /**
     *
     * @summary Create Backup
     * @param {string} readerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public createBackup(readerId: string, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).createBackup(readerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create Remote Backup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public createRemoteBackup(options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).createRemoteBackup(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Backup
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public deleteBackup(ids: Array<number>, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).deleteBackup(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Backups
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public getBackups(ids?: Array<string>, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).getBackups(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Configuration Backup
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public getConfigurationBackup(id: number, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).getConfigurationBackup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Restore Backup
     * @param {string} readerId
     * @param {number} backupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public restoreBackup(readerId: string, backupId: number, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).restoreBackup(readerId, backupId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DatasetDataApi - axios parameter creator
 * @export
 */
export const DatasetDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Clear Data
         * @param {Array<string>} requestBody
         * @param {boolean} [all]
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDatasetData: async (requestBody: Array<string>, all?: boolean, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('clearDatasetData', 'requestBody', requestBody)
            const localVarPath = `/rest/easas/datasetData/clearData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Dataset Data Aggregated
         * @param {{ [key: string]: AggregationType; }} requestBody
         * @param {ChronoUnit} [aggregationPeriod]
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetDataInfoAggregated: async (requestBody: { [key: string]: AggregationType; }, aggregationPeriod?: ChronoUnit, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getDatasetDataInfoAggregated', 'requestBody', requestBody)
            const localVarPath = `/rest/easas/datasetData/dataAggregatedInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aggregationPeriod !== undefined) {
                localVarQueryParameter['aggregationPeriod'] = aggregationPeriod;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Data Info Range
         * @param {Array<string>} requestBody
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetDataInfoRange: async (requestBody: Array<string>, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getDatasetDataInfoRange', 'requestBody', requestBody)
            const localVarPath = `/rest/easas/datasetData/dataInfoRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Data Info Recent
         * @param {Array<string>} requestBody
         * @param {number} [count]
         * @param {string} [refTime]
         * @param {boolean} [strict]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetDataInfoRecent: async (requestBody: Array<string>, count?: number, refTime?: string, strict?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getDatasetDataInfoRecent', 'requestBody', requestBody)
            const localVarPath = `/rest/easas/datasetData/dataInfoRecent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (refTime !== undefined) {
                localVarQueryParameter['refTime'] = (refTime as any instanceof Date) ?
                    (refTime as any).toISOString() :
                    refTime;
            }

            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Dataset Latest Values Batch
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetLatestValuesBatch: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getDatasetLatestValuesBatch', 'requestBody', requestBody)
            const localVarPath = `/rest/easas/datasetData/latest-values/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Dataset Data
         * @param {Array<UpdateDatasetData>} updateDatasetData
         * @param {boolean} [log]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetData: async (updateDatasetData: Array<UpdateDatasetData>, log?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDatasetData' is not null or undefined
            assertParamExists('updateDatasetData', 'updateDatasetData', updateDatasetData)
            const localVarPath = `/rest/easas/datasetData/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (log !== undefined) {
                localVarQueryParameter['log'] = log;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDatasetData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatasetDataApi - functional programming interface
 * @export
 */
export const DatasetDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatasetDataApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Clear Data
         * @param {Array<string>} requestBody
         * @param {boolean} [all]
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearDatasetData(requestBody: Array<string>, all?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearDatasetData(requestBody, all, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetDataApi.clearDatasetData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Dataset Data Aggregated
         * @param {{ [key: string]: AggregationType; }} requestBody
         * @param {ChronoUnit} [aggregationPeriod]
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetDataInfoAggregated(requestBody: { [key: string]: AggregationType; }, aggregationPeriod?: ChronoUnit, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: number; }; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetDataInfoAggregated(requestBody, aggregationPeriod, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetDataApi.getDatasetDataInfoAggregated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Data Info Range
         * @param {Array<string>} requestBody
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetDataInfoRange(requestBody: Array<string>, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetDataInfoResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetDataInfoRange(requestBody, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetDataApi.getDatasetDataInfoRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Data Info Recent
         * @param {Array<string>} requestBody
         * @param {number} [count]
         * @param {string} [refTime]
         * @param {boolean} [strict]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetDataInfoRecent(requestBody: Array<string>, count?: number, refTime?: string, strict?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetDataInfoResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetDataInfoRecent(requestBody, count, refTime, strict, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetDataApi.getDatasetDataInfoRecent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Dataset Latest Values Batch
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetLatestValuesBatch(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: InstantDoubleValue; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetLatestValuesBatch(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetDataApi.getDatasetLatestValuesBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Dataset Data
         * @param {Array<UpdateDatasetData>} updateDatasetData
         * @param {boolean} [log]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDatasetData(updateDatasetData: Array<UpdateDatasetData>, log?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDatasetData(updateDatasetData, log, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetDataApi.updateDatasetData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DatasetDataApi - factory interface
 * @export
 */
export const DatasetDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatasetDataApiFp(configuration)
    return {
        /**
         *
         * @summary Clear Data
         * @param {Array<string>} requestBody
         * @param {boolean} [all]
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDatasetData(requestBody: Array<string>, all?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearDatasetData(requestBody, all, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Dataset Data Aggregated
         * @param {{ [key: string]: AggregationType; }} requestBody
         * @param {ChronoUnit} [aggregationPeriod]
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetDataInfoAggregated(requestBody: { [key: string]: AggregationType; }, aggregationPeriod?: ChronoUnit, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: { [key: string]: number; }; }> {
            return localVarFp.getDatasetDataInfoAggregated(requestBody, aggregationPeriod, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Data Info Range
         * @param {Array<string>} requestBody
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetDataInfoRange(requestBody: Array<string>, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetDataInfoResponse>> {
            return localVarFp.getDatasetDataInfoRange(requestBody, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Data Info Recent
         * @param {Array<string>} requestBody
         * @param {number} [count]
         * @param {string} [refTime]
         * @param {boolean} [strict]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetDataInfoRecent(requestBody: Array<string>, count?: number, refTime?: string, strict?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetDataInfoResponse>> {
            return localVarFp.getDatasetDataInfoRecent(requestBody, count, refTime, strict, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Dataset Latest Values Batch
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetLatestValuesBatch(requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: InstantDoubleValue; }> {
            return localVarFp.getDatasetLatestValuesBatch(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Dataset Data
         * @param {Array<UpdateDatasetData>} updateDatasetData
         * @param {boolean} [log]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetData(updateDatasetData: Array<UpdateDatasetData>, log?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDatasetData(updateDatasetData, log, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatasetDataApi - object-oriented interface
 * @export
 * @class DatasetDataApi
 * @extends {BaseAPI}
 */
export class DatasetDataApi extends BaseAPI {
    /**
     *
     * @summary Clear Data
     * @param {Array<string>} requestBody
     * @param {boolean} [all]
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    public clearDatasetData(requestBody: Array<string>, all?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return DatasetDataApiFp(this.configuration).clearDatasetData(requestBody, all, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Dataset Data Aggregated
     * @param {{ [key: string]: AggregationType; }} requestBody
     * @param {ChronoUnit} [aggregationPeriod]
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    public getDatasetDataInfoAggregated(requestBody: { [key: string]: AggregationType; }, aggregationPeriod?: ChronoUnit, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return DatasetDataApiFp(this.configuration).getDatasetDataInfoAggregated(requestBody, aggregationPeriod, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Data Info Range
     * @param {Array<string>} requestBody
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    public getDatasetDataInfoRange(requestBody: Array<string>, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return DatasetDataApiFp(this.configuration).getDatasetDataInfoRange(requestBody, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Data Info Recent
     * @param {Array<string>} requestBody
     * @param {number} [count]
     * @param {string} [refTime]
     * @param {boolean} [strict]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    public getDatasetDataInfoRecent(requestBody: Array<string>, count?: number, refTime?: string, strict?: boolean, options?: RawAxiosRequestConfig) {
        return DatasetDataApiFp(this.configuration).getDatasetDataInfoRecent(requestBody, count, refTime, strict, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Dataset Latest Values Batch
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    public getDatasetLatestValuesBatch(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DatasetDataApiFp(this.configuration).getDatasetLatestValuesBatch(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Dataset Data
     * @param {Array<UpdateDatasetData>} updateDatasetData
     * @param {boolean} [log]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetDataApi
     */
    public updateDatasetData(updateDatasetData: Array<UpdateDatasetData>, log?: boolean, options?: RawAxiosRequestConfig) {
        return DatasetDataApiFp(this.configuration).updateDatasetData(updateDatasetData, log, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DatasetServiceDataResourceApi - axios parameter creator
 * @export
 */
export const DatasetServiceDataResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Clear Data
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearData: async (dataset: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('clearData', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                for (const [key, value] of Object.entries(from)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (to !== undefined) {
                for (const [key, value] of Object.entries(to)) {
                    localVarQueryParameter[key] = value;
                }
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Count
         * @param {number} dataset
         * @param {string} [from]
         * @param {boolean} [fromInclusive]
         * @param {string} [to]
         * @param {boolean} [toInclusive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        count: async (dataset: number, from?: string, fromInclusive?: boolean, to?: string, toInclusive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('count', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}/count`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                for (const [key, value] of Object.entries(from)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (fromInclusive !== undefined) {
                localVarQueryParameter['fromInclusive'] = fromInclusive;
            }

            if (to !== undefined) {
                for (const [key, value] of Object.entries(to)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (toInclusive !== undefined) {
                localVarQueryParameter['toInclusive'] = toInclusive;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Data
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getData: async (dataset: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('getData', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}/read`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                for (const [key, value] of Object.entries(from)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (to !== undefined) {
                for (const [key, value] of Object.entries(to)) {
                    localVarQueryParameter[key] = value;
                }
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Max Time
         * @param {number} dataset
         * @param {string} [relativeTime]
         * @param {number} [specificHour]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaxTime: async (dataset: number, relativeTime?: string, specificHour?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('getMaxTime', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}/maxTime`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (relativeTime !== undefined) {
                localVarQueryParameter['relativeTime'] = (relativeTime as any instanceof Date) ?
                    (relativeTime as any).toISOString() :
                    relativeTime;
            }

            if (specificHour !== undefined) {
                localVarQueryParameter['specificHour'] = specificHour;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Max Value
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaxValue: async (dataset: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('getMaxValue', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}/maxValue`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                for (const [key, value] of Object.entries(from)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (to !== undefined) {
                for (const [key, value] of Object.entries(to)) {
                    localVarQueryParameter[key] = value;
                }
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Min Time
         * @param {number} dataset
         * @param {string} [relativeTime]
         * @param {number} [specificHour]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinTime: async (dataset: number, relativeTime?: string, specificHour?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('getMinTime', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}/minTime`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (relativeTime !== undefined) {
                localVarQueryParameter['relativeTime'] = (relativeTime as any instanceof Date) ?
                    (relativeTime as any).toISOString() :
                    relativeTime;
            }

            if (specificHour !== undefined) {
                localVarQueryParameter['specificHour'] = specificHour;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Min Value
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinValue: async (dataset: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('getMinValue', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}/minValue`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                for (const [key, value] of Object.entries(from)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (to !== undefined) {
                for (const [key, value] of Object.entries(to)) {
                    localVarQueryParameter[key] = value;
                }
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Recent
         * @param {number} dataset
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecent: async (dataset: number, count?: number, referenceTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('getRecent', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}/readRecent`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (referenceTime !== undefined) {
                localVarQueryParameter['referenceTime'] = (referenceTime as any instanceof Date) ?
                    (referenceTime as any).toISOString() :
                    referenceTime;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Recent Batch
         * @param {number} [count]
         * @param {Array<number>} [id]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentBatch: async (count?: number, id?: Array<number>, referenceTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/datasetservice/data/readRecentBatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (id) {
                localVarQueryParameter['id'] = id;
            }

            if (referenceTime !== undefined) {
                localVarQueryParameter['referenceTime'] = (referenceTime as any instanceof Date) ?
                    (referenceTime as any).toISOString() :
                    referenceTime;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Has Value
         * @param {number} dataset
         * @param {string} [from]
         * @param {boolean} [fromInclusive]
         * @param {string} [to]
         * @param {boolean} [toInclusive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasValue: async (dataset: number, from?: string, fromInclusive?: boolean, to?: string, toInclusive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('hasValue', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}/hasValue`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                for (const [key, value] of Object.entries(from)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (fromInclusive !== undefined) {
                localVarQueryParameter['fromInclusive'] = fromInclusive;
            }

            if (to !== undefined) {
                for (const [key, value] of Object.entries(to)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (toInclusive !== undefined) {
                localVarQueryParameter['toInclusive'] = toInclusive;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Read One
         * @param {number} dataset
         * @param {string} [moment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOne: async (dataset: number, moment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('readOne', 'dataset', dataset)
            const localVarPath = `/rest/datasetservice/data/{dataset}/readOne`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (moment !== undefined) {
                localVarQueryParameter['moment'] = (moment as any instanceof Date) ?
                    (moment as any).toISOString() :
                    moment;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Dataset Values
         * @param {number} dataset
         * @param {Array<DatasetValue>} datasetValue
         * @param {boolean} [overwrite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetValues: async (dataset: number, datasetValue: Array<DatasetValue>, overwrite?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('updateDatasetValues', 'dataset', dataset)
            // verify required parameter 'datasetValue' is not null or undefined
            assertParamExists('updateDatasetValues', 'datasetValue', datasetValue)
            const localVarPath = `/rest/datasetservice/data/{dataset}/updateDataset`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (overwrite !== undefined) {
                localVarQueryParameter['overwrite'] = overwrite;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datasetValue, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Dataset Values Batch
         * @param {Array<DatasetDataUpdateDTO>} datasetDataUpdateDTO
         * @param {boolean} [overwrite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetValuesBatch: async (datasetDataUpdateDTO: Array<DatasetDataUpdateDTO>, overwrite?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetDataUpdateDTO' is not null or undefined
            assertParamExists('updateDatasetValuesBatch', 'datasetDataUpdateDTO', datasetDataUpdateDTO)
            const localVarPath = `/rest/datasetservice/data/updateDatasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (overwrite !== undefined) {
                localVarQueryParameter['overwrite'] = overwrite;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datasetDataUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Value
         * @param {number} dataset
         * @param {DatasetValue} datasetValue
         * @param {boolean} [overwrite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateValue: async (dataset: number, datasetValue: DatasetValue, overwrite?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataset' is not null or undefined
            assertParamExists('updateValue', 'dataset', dataset)
            // verify required parameter 'datasetValue' is not null or undefined
            assertParamExists('updateValue', 'datasetValue', datasetValue)
            const localVarPath = `/rest/datasetservice/data/{dataset}/updateValue`
                .replace(`{${"dataset"}}`, encodeURIComponent(String(dataset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (overwrite !== undefined) {
                localVarQueryParameter['overwrite'] = overwrite;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datasetValue, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatasetServiceDataResourceApi - functional programming interface
 * @export
 */
export const DatasetServiceDataResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatasetServiceDataResourceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Clear Data
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearData(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearData(dataset, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.clearData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Count
         * @param {number} dataset
         * @param {string} [from]
         * @param {boolean} [fromInclusive]
         * @param {string} [to]
         * @param {boolean} [toInclusive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async count(dataset: number, from?: string, fromInclusive?: boolean, to?: string, toInclusive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.count(dataset, from, fromInclusive, to, toInclusive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.count']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Data
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getData(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getData(dataset, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.getData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Max Time
         * @param {number} dataset
         * @param {string} [relativeTime]
         * @param {number} [specificHour]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaxTime(dataset: number, relativeTime?: string, specificHour?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaxTime(dataset, relativeTime, specificHour, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.getMaxTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Max Value
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaxValue(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetValue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaxValue(dataset, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.getMaxValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Min Time
         * @param {number} dataset
         * @param {string} [relativeTime]
         * @param {number} [specificHour]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMinTime(dataset: number, relativeTime?: string, specificHour?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMinTime(dataset, relativeTime, specificHour, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.getMinTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Min Value
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMinValue(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetValue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMinValue(dataset, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.getMinValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Recent
         * @param {number} dataset
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecent(dataset: number, count?: number, referenceTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecent(dataset, count, referenceTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.getRecent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Recent Batch
         * @param {number} [count]
         * @param {Array<number>} [id]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentBatch(count?: number, id?: Array<number>, referenceTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetValuesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentBatch(count, id, referenceTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.getRecentBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Has Value
         * @param {number} dataset
         * @param {string} [from]
         * @param {boolean} [fromInclusive]
         * @param {string} [to]
         * @param {boolean} [toInclusive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasValue(dataset: number, from?: string, fromInclusive?: boolean, to?: string, toInclusive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasValue(dataset, from, fromInclusive, to, toInclusive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.hasValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Read One
         * @param {number} dataset
         * @param {string} [moment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readOne(dataset: number, moment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetValue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readOne(dataset, moment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.readOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Dataset Values
         * @param {number} dataset
         * @param {Array<DatasetValue>} datasetValue
         * @param {boolean} [overwrite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDatasetValues(dataset: number, datasetValue: Array<DatasetValue>, overwrite?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDatasetValues(dataset, datasetValue, overwrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.updateDatasetValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Dataset Values Batch
         * @param {Array<DatasetDataUpdateDTO>} datasetDataUpdateDTO
         * @param {boolean} [overwrite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDatasetValuesBatch(datasetDataUpdateDTO: Array<DatasetDataUpdateDTO>, overwrite?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDatasetValuesBatch(datasetDataUpdateDTO, overwrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.updateDatasetValuesBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Value
         * @param {number} dataset
         * @param {DatasetValue} datasetValue
         * @param {boolean} [overwrite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateValue(dataset: number, datasetValue: DatasetValue, overwrite?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateValue(dataset, datasetValue, overwrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDataResourceApi.updateValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DatasetServiceDataResourceApi - factory interface
 * @export
 */
export const DatasetServiceDataResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatasetServiceDataResourceApiFp(configuration)
    return {
        /**
         *
         * @summary Clear Data
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearData(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearData(dataset, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Count
         * @param {number} dataset
         * @param {string} [from]
         * @param {boolean} [fromInclusive]
         * @param {string} [to]
         * @param {boolean} [toInclusive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        count(dataset: number, from?: string, fromInclusive?: boolean, to?: string, toInclusive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.count(dataset, from, fromInclusive, to, toInclusive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Data
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getData(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetValue>> {
            return localVarFp.getData(dataset, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Max Time
         * @param {number} dataset
         * @param {string} [relativeTime]
         * @param {number} [specificHour]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaxTime(dataset: number, relativeTime?: string, specificHour?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getMaxTime(dataset, relativeTime, specificHour, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Max Value
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaxValue(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetValue> {
            return localVarFp.getMaxValue(dataset, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Min Time
         * @param {number} dataset
         * @param {string} [relativeTime]
         * @param {number} [specificHour]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinTime(dataset: number, relativeTime?: string, specificHour?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getMinTime(dataset, relativeTime, specificHour, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Min Value
         * @param {number} dataset
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinValue(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetValue> {
            return localVarFp.getMinValue(dataset, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Recent
         * @param {number} dataset
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecent(dataset: number, count?: number, referenceTime?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetValue>> {
            return localVarFp.getRecent(dataset, count, referenceTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Recent Batch
         * @param {number} [count]
         * @param {Array<number>} [id]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentBatch(count?: number, id?: Array<number>, referenceTime?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetValuesDTO>> {
            return localVarFp.getRecentBatch(count, id, referenceTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Has Value
         * @param {number} dataset
         * @param {string} [from]
         * @param {boolean} [fromInclusive]
         * @param {string} [to]
         * @param {boolean} [toInclusive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasValue(dataset: number, from?: string, fromInclusive?: boolean, to?: string, toInclusive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.hasValue(dataset, from, fromInclusive, to, toInclusive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Read One
         * @param {number} dataset
         * @param {string} [moment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOne(dataset: number, moment?: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetValue> {
            return localVarFp.readOne(dataset, moment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Dataset Values
         * @param {number} dataset
         * @param {Array<DatasetValue>} datasetValue
         * @param {boolean} [overwrite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetValues(dataset: number, datasetValue: Array<DatasetValue>, overwrite?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDatasetValues(dataset, datasetValue, overwrite, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Dataset Values Batch
         * @param {Array<DatasetDataUpdateDTO>} datasetDataUpdateDTO
         * @param {boolean} [overwrite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetValuesBatch(datasetDataUpdateDTO: Array<DatasetDataUpdateDTO>, overwrite?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDatasetValuesBatch(datasetDataUpdateDTO, overwrite, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Value
         * @param {number} dataset
         * @param {DatasetValue} datasetValue
         * @param {boolean} [overwrite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateValue(dataset: number, datasetValue: DatasetValue, overwrite?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateValue(dataset, datasetValue, overwrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatasetServiceDataResourceApi - object-oriented interface
 * @export
 * @class DatasetServiceDataResourceApi
 * @extends {BaseAPI}
 */
export class DatasetServiceDataResourceApi extends BaseAPI {
    /**
     *
     * @summary Clear Data
     * @param {number} dataset
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public clearData(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).clearData(dataset, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Count
     * @param {number} dataset
     * @param {string} [from]
     * @param {boolean} [fromInclusive]
     * @param {string} [to]
     * @param {boolean} [toInclusive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public count(dataset: number, from?: string, fromInclusive?: boolean, to?: string, toInclusive?: boolean, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).count(dataset, from, fromInclusive, to, toInclusive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Data
     * @param {number} dataset
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public getData(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).getData(dataset, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Max Time
     * @param {number} dataset
     * @param {string} [relativeTime]
     * @param {number} [specificHour]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public getMaxTime(dataset: number, relativeTime?: string, specificHour?: number, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).getMaxTime(dataset, relativeTime, specificHour, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Max Value
     * @param {number} dataset
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public getMaxValue(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).getMaxValue(dataset, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Min Time
     * @param {number} dataset
     * @param {string} [relativeTime]
     * @param {number} [specificHour]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public getMinTime(dataset: number, relativeTime?: string, specificHour?: number, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).getMinTime(dataset, relativeTime, specificHour, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Min Value
     * @param {number} dataset
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public getMinValue(dataset: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).getMinValue(dataset, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Recent
     * @param {number} dataset
     * @param {number} [count]
     * @param {string} [referenceTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public getRecent(dataset: number, count?: number, referenceTime?: string, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).getRecent(dataset, count, referenceTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Recent Batch
     * @param {number} [count]
     * @param {Array<number>} [id]
     * @param {string} [referenceTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public getRecentBatch(count?: number, id?: Array<number>, referenceTime?: string, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).getRecentBatch(count, id, referenceTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Has Value
     * @param {number} dataset
     * @param {string} [from]
     * @param {boolean} [fromInclusive]
     * @param {string} [to]
     * @param {boolean} [toInclusive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public hasValue(dataset: number, from?: string, fromInclusive?: boolean, to?: string, toInclusive?: boolean, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).hasValue(dataset, from, fromInclusive, to, toInclusive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Read One
     * @param {number} dataset
     * @param {string} [moment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public readOne(dataset: number, moment?: string, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).readOne(dataset, moment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Dataset Values
     * @param {number} dataset
     * @param {Array<DatasetValue>} datasetValue
     * @param {boolean} [overwrite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public updateDatasetValues(dataset: number, datasetValue: Array<DatasetValue>, overwrite?: boolean, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).updateDatasetValues(dataset, datasetValue, overwrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Dataset Values Batch
     * @param {Array<DatasetDataUpdateDTO>} datasetDataUpdateDTO
     * @param {boolean} [overwrite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public updateDatasetValuesBatch(datasetDataUpdateDTO: Array<DatasetDataUpdateDTO>, overwrite?: boolean, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).updateDatasetValuesBatch(datasetDataUpdateDTO, overwrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Value
     * @param {number} dataset
     * @param {DatasetValue} datasetValue
     * @param {boolean} [overwrite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDataResourceApi
     */
    public updateValue(dataset: number, datasetValue: DatasetValue, overwrite?: boolean, options?: RawAxiosRequestConfig) {
        return DatasetServiceDataResourceApiFp(this.configuration).updateValue(dataset, datasetValue, overwrite, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DatasetServiceDatasetApi - axios parameter creator
 * @export
 */
export const DatasetServiceDatasetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Dataset
         * @param {RemoteDatasetDTO} remoteDatasetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataset: async (remoteDatasetDTO: RemoteDatasetDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'remoteDatasetDTO' is not null or undefined
            assertParamExists('createDataset', 'remoteDatasetDTO', remoteDatasetDTO)
            const localVarPath = `/rest/datasetservice/datasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(remoteDatasetDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Dataset
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataset: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDataset', 'id', id)
            const localVarPath = `/rest/datasetservice/datasets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Dataset By Id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDatasetById', 'id', id)
            const localVarPath = `/rest/datasetservice/datasets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Datasets
         * @param {number} [categoryId]
         * @param {string} [clientId]
         * @param {number} [companyId]
         * @param {number} [deviceId]
         * @param {number} [fetch]
         * @param {number} [groupId]
         * @param {Set<string>} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasets: async (categoryId?: number, clientId?: string, companyId?: number, deviceId?: number, fetch?: number, groupId?: number, tags?: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/datasetservice/datasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (fetch !== undefined) {
                localVarQueryParameter['fetch'] = fetch;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (tags) {
                localVarQueryParameter['tags'] = Array.from(tags);
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Datasets By Batch
         * @param {Array<number>} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBatch: async (id?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/datasetservice/datasets/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id) {
                localVarQueryParameter['id'] = id;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Dataset
         * @param {number} id
         * @param {RemoteDatasetDTO} remoteDatasetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDataset: async (id: number, remoteDatasetDTO: RemoteDatasetDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDataset', 'id', id)
            // verify required parameter 'remoteDatasetDTO' is not null or undefined
            assertParamExists('updateDataset', 'remoteDatasetDTO', remoteDatasetDTO)
            const localVarPath = `/rest/datasetservice/datasets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(remoteDatasetDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatasetServiceDatasetApi - functional programming interface
 * @export
 */
export const DatasetServiceDatasetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatasetServiceDatasetApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Dataset
         * @param {RemoteDatasetDTO} remoteDatasetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDataset(remoteDatasetDTO: RemoteDatasetDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoteDatasetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDataset(remoteDatasetDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDatasetApi.createDataset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Dataset
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDataset(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoteDatasetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDataset(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDatasetApi.deleteDataset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Dataset By Id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoteDatasetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDatasetApi.getDatasetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Datasets
         * @param {number} [categoryId]
         * @param {string} [clientId]
         * @param {number} [companyId]
         * @param {number} [deviceId]
         * @param {number} [fetch]
         * @param {number} [groupId]
         * @param {Set<string>} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasets(categoryId?: number, clientId?: string, companyId?: number, deviceId?: number, fetch?: number, groupId?: number, tags?: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RemoteDatasetDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasets(categoryId, clientId, companyId, deviceId, fetch, groupId, tags, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDatasetApi.getDatasets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Datasets By Batch
         * @param {Array<number>} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetsByBatch(id?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RemoteDatasetDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetsByBatch(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDatasetApi.getDatasetsByBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Dataset
         * @param {number} id
         * @param {RemoteDatasetDTO} remoteDatasetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDataset(id: number, remoteDatasetDTO: RemoteDatasetDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoteDatasetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDataset(id, remoteDatasetDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetServiceDatasetApi.updateDataset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DatasetServiceDatasetApi - factory interface
 * @export
 */
export const DatasetServiceDatasetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatasetServiceDatasetApiFp(configuration)
    return {
        /**
         *
         * @summary Create Dataset
         * @param {RemoteDatasetDTO} remoteDatasetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataset(remoteDatasetDTO: RemoteDatasetDTO, options?: RawAxiosRequestConfig): AxiosPromise<RemoteDatasetDTO> {
            return localVarFp.createDataset(remoteDatasetDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Dataset
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataset(id: number, options?: RawAxiosRequestConfig): AxiosPromise<RemoteDatasetDTO> {
            return localVarFp.deleteDataset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Dataset By Id
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<RemoteDatasetDTO> {
            return localVarFp.getDatasetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Datasets
         * @param {number} [categoryId]
         * @param {string} [clientId]
         * @param {number} [companyId]
         * @param {number} [deviceId]
         * @param {number} [fetch]
         * @param {number} [groupId]
         * @param {Set<string>} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasets(categoryId?: number, clientId?: string, companyId?: number, deviceId?: number, fetch?: number, groupId?: number, tags?: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<RemoteDatasetDTO>> {
            return localVarFp.getDatasets(categoryId, clientId, companyId, deviceId, fetch, groupId, tags, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Datasets By Batch
         * @param {Array<number>} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBatch(id?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<RemoteDatasetDTO>> {
            return localVarFp.getDatasetsByBatch(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Dataset
         * @param {number} id
         * @param {RemoteDatasetDTO} remoteDatasetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDataset(id: number, remoteDatasetDTO: RemoteDatasetDTO, options?: RawAxiosRequestConfig): AxiosPromise<RemoteDatasetDTO> {
            return localVarFp.updateDataset(id, remoteDatasetDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatasetServiceDatasetApi - object-oriented interface
 * @export
 * @class DatasetServiceDatasetApi
 * @extends {BaseAPI}
 */
export class DatasetServiceDatasetApi extends BaseAPI {
    /**
     *
     * @summary Create Dataset
     * @param {RemoteDatasetDTO} remoteDatasetDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDatasetApi
     */
    public createDataset(remoteDatasetDTO: RemoteDatasetDTO, options?: RawAxiosRequestConfig) {
        return DatasetServiceDatasetApiFp(this.configuration).createDataset(remoteDatasetDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Dataset
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDatasetApi
     */
    public deleteDataset(id: number, options?: RawAxiosRequestConfig) {
        return DatasetServiceDatasetApiFp(this.configuration).deleteDataset(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Dataset By Id
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDatasetApi
     */
    public getDatasetById(id: number, options?: RawAxiosRequestConfig) {
        return DatasetServiceDatasetApiFp(this.configuration).getDatasetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Datasets
     * @param {number} [categoryId]
     * @param {string} [clientId]
     * @param {number} [companyId]
     * @param {number} [deviceId]
     * @param {number} [fetch]
     * @param {number} [groupId]
     * @param {Set<string>} [tags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDatasetApi
     */
    public getDatasets(categoryId?: number, clientId?: string, companyId?: number, deviceId?: number, fetch?: number, groupId?: number, tags?: Set<string>, options?: RawAxiosRequestConfig) {
        return DatasetServiceDatasetApiFp(this.configuration).getDatasets(categoryId, clientId, companyId, deviceId, fetch, groupId, tags, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Datasets By Batch
     * @param {Array<number>} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDatasetApi
     */
    public getDatasetsByBatch(id?: Array<number>, options?: RawAxiosRequestConfig) {
        return DatasetServiceDatasetApiFp(this.configuration).getDatasetsByBatch(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Dataset
     * @param {number} id
     * @param {RemoteDatasetDTO} remoteDatasetDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetServiceDatasetApi
     */
    public updateDataset(id: number, remoteDatasetDTO: RemoteDatasetDTO, options?: RawAxiosRequestConfig) {
        return DatasetServiceDatasetApiFp(this.configuration).updateDataset(id, remoteDatasetDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EASASDataApi - axios parameter creator
 * @export
 */
export const EASASDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get actual dataset data in the provided data period
         * @summary Get Dataset Data
         * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetData: async (dataObj: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataObj' is not null or undefined
            assertParamExists('getDatasetData', 'dataObj', dataObj)
            const localVarPath = `/rest/easas/datasets/data/interval/{dataObj}`
                .replace(`{${"dataObj"}}`, encodeURIComponent(String(dataObj)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
         * @summary Get Dataset Data Aggregated
         * @param {ChronoUnit} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
         * @param {string} from Instant object which represents the start of the data period
         * @param {string} to Instant object which represents the end of the data period
         * @param {{ [key: string]: AggregationType; }} requestBody
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getDatasetDataAggregated: async (aggregationPeriod: ChronoUnit, from: string, to: string, requestBody: { [key: string]: AggregationType; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregationPeriod' is not null or undefined
            assertParamExists('getDatasetDataAggregated', 'aggregationPeriod', aggregationPeriod)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getDatasetDataAggregated', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getDatasetDataAggregated', 'to', to)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getDatasetDataAggregated', 'requestBody', requestBody)
            const localVarPath = `/rest/easas/datasets/data/intervalAggregated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aggregationPeriod !== undefined) {
                localVarQueryParameter['aggregationPeriod'] = aggregationPeriod;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
         * @summary Get Dataset Most Recent Values
         * @param {number} datasetId Categorized dataset database ID
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetMostRecentValues: async (datasetId: number, adjustContinuous?: boolean, count?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getDatasetMostRecentValues', 'datasetId', datasetId)
            const localVarPath = `/rest/easas/datasets/data/recent/{datasetId}`
                .replace(`{${"datasetId"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adjustContinuous !== undefined) {
                localVarQueryParameter['adjustContinuous'] = adjustContinuous;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Most Recent Data
         * @param {string} _class
         * @param {number} datasetId
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostRecentData: async (_class: string, datasetId: number, adjustContinuous?: boolean, count?: number, referenceTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '_class' is not null or undefined
            assertParamExists('getMostRecentData', '_class', _class)
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getMostRecentData', 'datasetId', datasetId)
            const localVarPath = `/rest/easas/datasets/data/recent/{class}/{datasetId}`
                .replace(`{${"class"}}`, encodeURIComponent(String(_class)))
                .replace(`{${"datasetId"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adjustContinuous !== undefined) {
                localVarQueryParameter['adjustContinuous'] = adjustContinuous;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (referenceTime !== undefined) {
                localVarQueryParameter['referenceTime'] = (referenceTime as any instanceof Date) ?
                    (referenceTime as any).toISOString() :
                    referenceTime;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @summary Get Recent Values
         * @param {Array<string>} requestBody
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentValues: async (requestBody: Array<string>, adjustContinuous?: boolean, alignTimeUnit?: string, lead?: number, leadTimeUnit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getRecentValues', 'requestBody', requestBody)
            const localVarPath = `/rest/easas/datasets/data/recentValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adjustContinuous !== undefined) {
                localVarQueryParameter['adjustContinuous'] = adjustContinuous;
            }

            if (alignTimeUnit !== undefined) {
                localVarQueryParameter['alignTimeUnit'] = alignTimeUnit;
            }

            if (lead !== undefined) {
                localVarQueryParameter['lead'] = lead;
            }

            if (leadTimeUnit !== undefined) {
                localVarQueryParameter['leadTimeUnit'] = leadTimeUnit;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @summary Get Recent Values Old
         * @param {Array<string>} requestBody
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRecentValuesOld: async (requestBody: Array<string>, alignTimeUnit?: string, lead?: number, leadTimeUnit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getRecentValuesOld', 'requestBody', requestBody)
            const localVarPath = `/rest/easas/datasets/data/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (alignTimeUnit !== undefined) {
                localVarQueryParameter['alignTimeUnit'] = alignTimeUnit;
            }

            if (lead !== undefined) {
                localVarQueryParameter['lead'] = lead;
            }

            if (leadTimeUnit !== undefined) {
                localVarQueryParameter['leadTimeUnit'] = leadTimeUnit;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EASASDataApi - functional programming interface
 * @export
 */
export const EASASDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EASASDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Get actual dataset data in the provided data period
         * @summary Get Dataset Data
         * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetData(dataObj: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeMomentValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetData(dataObj, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDataApi.getDatasetData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
         * @summary Get Dataset Data Aggregated
         * @param {ChronoUnit} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
         * @param {string} from Instant object which represents the start of the data period
         * @param {string} to Instant object which represents the end of the data period
         * @param {{ [key: string]: AggregationType; }} requestBody
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getDatasetDataAggregated(aggregationPeriod: ChronoUnit, from: string, to: string, requestBody: { [key: string]: AggregationType; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: number; }; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetDataAggregated(aggregationPeriod, from, to, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDataApi.getDatasetDataAggregated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
         * @summary Get Dataset Most Recent Values
         * @param {number} datasetId Categorized dataset database ID
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetMostRecentValues(datasetId: number, adjustContinuous?: boolean, count?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeMomentValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetMostRecentValues(datasetId, adjustContinuous, count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDataApi.getDatasetMostRecentValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Most Recent Data
         * @param {string} _class
         * @param {number} datasetId
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMostRecentData(_class: string, datasetId: number, adjustContinuous?: boolean, count?: number, referenceTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeMomentValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMostRecentData(_class, datasetId, adjustContinuous, count, referenceTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDataApi.getMostRecentData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @summary Get Recent Values
         * @param {Array<string>} requestBody
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentValues(requestBody: Array<string>, adjustContinuous?: boolean, alignTimeUnit?: string, lead?: number, leadTimeUnit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: TimeMomentValue; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentValues(requestBody, adjustContinuous, alignTimeUnit, lead, leadTimeUnit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDataApi.getRecentValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @summary Get Recent Values Old
         * @param {Array<string>} requestBody
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getRecentValuesOld(requestBody: Array<string>, alignTimeUnit?: string, lead?: number, leadTimeUnit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeMomentValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentValuesOld(requestBody, alignTimeUnit, lead, leadTimeUnit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDataApi.getRecentValuesOld']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EASASDataApi - factory interface
 * @export
 */
export const EASASDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EASASDataApiFp(configuration)
    return {
        /**
         * Get actual dataset data in the provided data period
         * @summary Get Dataset Data
         * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetData(dataObj: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TimeMomentValue>> {
            return localVarFp.getDatasetData(dataObj, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
         * @summary Get Dataset Data Aggregated
         * @param {ChronoUnit} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
         * @param {string} from Instant object which represents the start of the data period
         * @param {string} to Instant object which represents the end of the data period
         * @param {{ [key: string]: AggregationType; }} requestBody
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getDatasetDataAggregated(aggregationPeriod: ChronoUnit, from: string, to: string, requestBody: { [key: string]: AggregationType; }, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: { [key: string]: number; }; }> {
            return localVarFp.getDatasetDataAggregated(aggregationPeriod, from, to, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
         * @summary Get Dataset Most Recent Values
         * @param {number} datasetId Categorized dataset database ID
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetMostRecentValues(datasetId: number, adjustContinuous?: boolean, count?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TimeMomentValue>> {
            return localVarFp.getDatasetMostRecentValues(datasetId, adjustContinuous, count, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Most Recent Data
         * @param {string} _class
         * @param {number} datasetId
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostRecentData(_class: string, datasetId: number, adjustContinuous?: boolean, count?: number, referenceTime?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TimeMomentValue>> {
            return localVarFp.getMostRecentData(_class, datasetId, adjustContinuous, count, referenceTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @summary Get Recent Values
         * @param {Array<string>} requestBody
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentValues(requestBody: Array<string>, adjustContinuous?: boolean, alignTimeUnit?: string, lead?: number, leadTimeUnit?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: TimeMomentValue; }> {
            return localVarFp.getRecentValues(requestBody, adjustContinuous, alignTimeUnit, lead, leadTimeUnit, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @summary Get Recent Values Old
         * @param {Array<string>} requestBody
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRecentValuesOld(requestBody: Array<string>, alignTimeUnit?: string, lead?: number, leadTimeUnit?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TimeMomentValue>> {
            return localVarFp.getRecentValuesOld(requestBody, alignTimeUnit, lead, leadTimeUnit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EASASDataApi - object-oriented interface
 * @export
 * @class EASASDataApi
 * @extends {BaseAPI}
 */
export class EASASDataApi extends BaseAPI {
    /**
     * Get actual dataset data in the provided data period
     * @summary Get Dataset Data
     * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDataApi
     */
    public getDatasetData(dataObj: string, options?: RawAxiosRequestConfig) {
        return EASASDataApiFp(this.configuration).getDatasetData(dataObj, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
     * @summary Get Dataset Data Aggregated
     * @param {ChronoUnit} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
     * @param {string} from Instant object which represents the start of the data period
     * @param {string} to Instant object which represents the end of the data period
     * @param {{ [key: string]: AggregationType; }} requestBody
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EASASDataApi
     */
    public getDatasetDataAggregated(aggregationPeriod: ChronoUnit, from: string, to: string, requestBody: { [key: string]: AggregationType; }, options?: RawAxiosRequestConfig) {
        return EASASDataApiFp(this.configuration).getDatasetDataAggregated(aggregationPeriod, from, to, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
     * @summary Get Dataset Most Recent Values
     * @param {number} datasetId Categorized dataset database ID
     * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
     * @param {number} [count]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDataApi
     */
    public getDatasetMostRecentValues(datasetId: number, adjustContinuous?: boolean, count?: number, options?: RawAxiosRequestConfig) {
        return EASASDataApiFp(this.configuration).getDatasetMostRecentValues(datasetId, adjustContinuous, count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Most Recent Data
     * @param {string} _class
     * @param {number} datasetId
     * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
     * @param {number} [count]
     * @param {string} [referenceTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDataApi
     */
    public getMostRecentData(_class: string, datasetId: number, adjustContinuous?: boolean, count?: number, referenceTime?: string, options?: RawAxiosRequestConfig) {
        return EASASDataApiFp(this.configuration).getMostRecentData(_class, datasetId, adjustContinuous, count, referenceTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
     * @summary Get Recent Values
     * @param {Array<string>} requestBody
     * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
     * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
     * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
     * @param {string} [leadTimeUnit] Time lead ChronoUnit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDataApi
     */
    public getRecentValues(requestBody: Array<string>, adjustContinuous?: boolean, alignTimeUnit?: string, lead?: number, leadTimeUnit?: string, options?: RawAxiosRequestConfig) {
        return EASASDataApiFp(this.configuration).getRecentValues(requestBody, adjustContinuous, alignTimeUnit, lead, leadTimeUnit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
     * @summary Get Recent Values Old
     * @param {Array<string>} requestBody
     * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
     * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
     * @param {string} [leadTimeUnit] Time lead ChronoUnit
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EASASDataApi
     */
    public getRecentValuesOld(requestBody: Array<string>, alignTimeUnit?: string, lead?: number, leadTimeUnit?: string, options?: RawAxiosRequestConfig) {
        return EASASDataApiFp(this.configuration).getRecentValuesOld(requestBody, alignTimeUnit, lead, leadTimeUnit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EASASDatasetsApi - axios parameter creator
 * @export
 */
export const EASASDatasetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create categorized(local and remote) dataset
         * @summary Create Categorized Dataset
         * @param {DatasetInfo} datasetInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategorizedDataset: async (datasetInfo: DatasetInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetInfo' is not null or undefined
            assertParamExists('createCategorizedDataset', 'datasetInfo', datasetInfo)
            const localVarPath = `/rest/easas/datasets/create-categorized`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datasetInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get All Dataset Infos Paginated
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {number} [page]
         * @param {string} [query]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDatasetInfos: async (allowEmptyQuery?: boolean, identifiers?: string, page?: number, query?: string, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/infos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (allowEmptyQuery !== undefined) {
                localVarQueryParameter['allowEmptyQuery'] = allowEmptyQuery;
            }

            if (identifiers !== undefined) {
                localVarQueryParameter['identifiers'] = identifiers;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all allowed datasets for request user
         * @summary Get Allowed Datasets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllowedDatasets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/allowed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Base Dataset
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseDataset: async (identifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('getBaseDataset', 'identifier', identifier)
            const localVarPath = `/rest/easas/datasets/{identifier}`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Categories
         * @param {string} [categoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (categoryIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryIds !== undefined) {
                localVarQueryParameter['categoryIds'] = categoryIds;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Company Category Info
         * @param {number} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryInfo: async (category?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/categoryInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Dataset Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all request user company dataset groups
         * @summary Get Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Dataset Info
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetInfo: async (identifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('getDatasetInfo', 'identifier', identifier)
            const localVarPath = `/rest/easas/datasets/{identifier}/info`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all user allowed datasets in DatasetDTO format
         * @summary Get Dataset List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Datasets By Binding
         * @param {string} id
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBinding: async (id: string, type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDatasetsByBinding', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getDatasetsByBinding', 'type', type)
            const localVarPath = `/rest/easas/datasets/by-binding/{type}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Datasets By Category
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByCategory: async (categoryId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/byCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Datasets By Group
         * @param {number} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByGroup: async (groupId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/byGroup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Dataset By Tags
         * @param {number} [categoryId]
         * @param {string} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByTags: async (categoryId?: number, tags?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/byTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Default Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultCategory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/categories/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Datasets
         * @param {DatasetRequestFilter} datasetRequestFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEasasDatasets: async (datasetRequestFilter: DatasetRequestFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetRequestFilter' is not null or undefined
            assertParamExists('getEasasDatasets', 'datasetRequestFilter', datasetRequestFilter)
            const localVarPath = `/rest/easas/datasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datasetRequestFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get dataset group object by database id
         * @summary Get Group
         * @param {number} groupId Dataset group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup: async (groupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getGroup', 'groupId', groupId)
            const localVarPath = `/rest/easas/datasets/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Query Dataset Count
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueryDatasetCount: async (allowEmptyQuery?: boolean, identifiers?: string, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/search/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (allowEmptyQuery !== undefined) {
                localVarQueryParameter['allowEmptyQuery'] = allowEmptyQuery;
            }

            if (identifiers !== undefined) {
                localVarQueryParameter['identifiers'] = identifiers;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search datasets by query string
         * @summary Query Datasets
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDatasets: async (allowEmptyQuery?: boolean, identifiers?: string, limit?: number, page?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (allowEmptyQuery !== undefined) {
                localVarQueryParameter['allowEmptyQuery'] = allowEmptyQuery;
            }

            if (identifiers !== undefined) {
                localVarQueryParameter['identifiers'] = identifiers;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft Delete Dataset
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteDataset: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('softDeleteDataset', 'id', id)
            const localVarPath = `/rest/easas/datasets/{id}/soft-delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Dataset Info
         * @param {string} id
         * @param {DatasetInfo} datasetInfo
         * @param {boolean} [fullUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetInfo: async (id: string, datasetInfo: DatasetInfo, fullUpdate?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDatasetInfo', 'id', id)
            // verify required parameter 'datasetInfo' is not null or undefined
            assertParamExists('updateDatasetInfo', 'datasetInfo', datasetInfo)
            const localVarPath = `/rest/easas/datasets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fullUpdate !== undefined) {
                localVarQueryParameter['fullUpdate'] = fullUpdate;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datasetInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EASASDatasetsApi - functional programming interface
 * @export
 */
export const EASASDatasetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EASASDatasetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create categorized(local and remote) dataset
         * @summary Create Categorized Dataset
         * @param {DatasetInfo} datasetInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategorizedDataset(datasetInfo: DatasetInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategorizedDataset(datasetInfo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.createCategorizedDataset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get All Dataset Infos Paginated
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {number} [page]
         * @param {string} [query]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDatasetInfos(allowEmptyQuery?: boolean, identifiers?: string, page?: number, query?: string, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDatasetInfos(allowEmptyQuery, identifiers, page, query, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getAllDatasetInfos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all allowed datasets for request user
         * @summary Get Allowed Datasets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllowedDatasets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetExtendedIdentifier>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllowedDatasets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getAllowedDatasets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Base Dataset
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBaseDataset(identifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBaseDataset(identifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getBaseDataset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Categories
         * @param {string} [categoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(categoryIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetCategoryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(categoryIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Company Category Info
         * @param {number} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryInfo(category?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryInfo(category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getCategoryInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Dataset Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getDatasetCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all request user company dataset groups
         * @summary Get Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetGroup>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getDatasetGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Dataset Info
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetInfo(identifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetInfo(identifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getDatasetInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all user allowed datasets in DatasetDTO format
         * @summary Get Dataset List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getDatasetList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Datasets By Binding
         * @param {string} id
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetsByBinding(id: string, type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetsByBinding(id, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getDatasetsByBinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Datasets By Category
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetsByCategory(categoryId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetsByCategory(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getDatasetsByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Datasets By Group
         * @param {number} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetsByGroup(groupId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetsByGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getDatasetsByGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Dataset By Tags
         * @param {number} [categoryId]
         * @param {string} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetsByTags(categoryId?: number, tags?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetsByTags(categoryId, tags, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getDatasetsByTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Default Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultCategory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetCategoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultCategory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getDefaultCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Datasets
         * @param {DatasetRequestFilter} datasetRequestFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEasasDatasets(datasetRequestFilter: DatasetRequestFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEasasDatasets(datasetRequestFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getEasasDatasets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get dataset group object by database id
         * @summary Get Group
         * @param {number} groupId Dataset group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroup(groupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Query Dataset Count
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueryDatasetCount(allowEmptyQuery?: boolean, identifiers?: string, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueryDatasetCount(allowEmptyQuery, identifiers, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.getQueryDatasetCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search datasets by query string
         * @summary Query Datasets
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDatasets(allowEmptyQuery?: boolean, identifiers?: string, limit?: number, page?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDatasets(allowEmptyQuery, identifiers, limit, page, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.searchDatasets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft Delete Dataset
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softDeleteDataset(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softDeleteDataset(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.softDeleteDataset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Dataset Info
         * @param {string} id
         * @param {DatasetInfo} datasetInfo
         * @param {boolean} [fullUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDatasetInfo(id: string, datasetInfo: DatasetInfo, fullUpdate?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDatasetInfo(id, datasetInfo, fullUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsApi.updateDatasetInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EASASDatasetsApi - factory interface
 * @export
 */
export const EASASDatasetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EASASDatasetsApiFp(configuration)
    return {
        /**
         * Create categorized(local and remote) dataset
         * @summary Create Categorized Dataset
         * @param {DatasetInfo} datasetInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategorizedDataset(datasetInfo: DatasetInfo, options?: RawAxiosRequestConfig): AxiosPromise<DatasetInfo> {
            return localVarFp.createCategorizedDataset(datasetInfo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get All Dataset Infos Paginated
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {number} [page]
         * @param {string} [query]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDatasetInfos(allowEmptyQuery?: boolean, identifiers?: string, page?: number, query?: string, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetInfo>> {
            return localVarFp.getAllDatasetInfos(allowEmptyQuery, identifiers, page, query, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all allowed datasets for request user
         * @summary Get Allowed Datasets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllowedDatasets(options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetExtendedIdentifier>> {
            return localVarFp.getAllowedDatasets(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Base Dataset
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseDataset(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetInfo> {
            return localVarFp.getBaseDataset(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Categories
         * @param {string} [categoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(categoryIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetCategoryDTO>> {
            return localVarFp.getCategories(categoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Company Category Info
         * @param {number} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryInfo(category?: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getCategoryInfo(category, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Dataset Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetCount(options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getDatasetCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all request user company dataset groups
         * @summary Get Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetGroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetGroup>> {
            return localVarFp.getDatasetGroups(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Dataset Info
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetInfo(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetInfo> {
            return localVarFp.getDatasetInfo(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all user allowed datasets in DatasetDTO format
         * @summary Get Dataset List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetList(options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetDTO>> {
            return localVarFp.getDatasetList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Datasets By Binding
         * @param {string} id
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBinding(id: string, type: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetInfo>> {
            return localVarFp.getDatasetsByBinding(id, type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Datasets By Category
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByCategory(categoryId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetInfo>> {
            return localVarFp.getDatasetsByCategory(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Datasets By Group
         * @param {number} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByGroup(groupId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetInfo>> {
            return localVarFp.getDatasetsByGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Dataset By Tags
         * @param {number} [categoryId]
         * @param {string} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByTags(categoryId?: number, tags?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetInfo>> {
            return localVarFp.getDatasetsByTags(categoryId, tags, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Default Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultCategory(options?: RawAxiosRequestConfig): AxiosPromise<DatasetCategoryDTO> {
            return localVarFp.getDefaultCategory(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Datasets
         * @param {DatasetRequestFilter} datasetRequestFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEasasDatasets(datasetRequestFilter: DatasetRequestFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetDTO>> {
            return localVarFp.getEasasDatasets(datasetRequestFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset group object by database id
         * @summary Get Group
         * @param {number} groupId Dataset group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(groupId: number, options?: RawAxiosRequestConfig): AxiosPromise<DatasetGroup> {
            return localVarFp.getGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Query Dataset Count
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueryDatasetCount(allowEmptyQuery?: boolean, identifiers?: string, query?: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getQueryDatasetCount(allowEmptyQuery, identifiers, query, options).then((request) => request(axios, basePath));
        },
        /**
         * Search datasets by query string
         * @summary Query Datasets
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDatasets(allowEmptyQuery?: boolean, identifiers?: string, limit?: number, page?: number, query?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetInfo>> {
            return localVarFp.searchDatasets(allowEmptyQuery, identifiers, limit, page, query, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft Delete Dataset
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteDataset(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetInfo> {
            return localVarFp.softDeleteDataset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Dataset Info
         * @param {string} id
         * @param {DatasetInfo} datasetInfo
         * @param {boolean} [fullUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetInfo(id: string, datasetInfo: DatasetInfo, fullUpdate?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DatasetInfo> {
            return localVarFp.updateDatasetInfo(id, datasetInfo, fullUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EASASDatasetsApi - object-oriented interface
 * @export
 * @class EASASDatasetsApi
 * @extends {BaseAPI}
 */
export class EASASDatasetsApi extends BaseAPI {
    /**
     * Create categorized(local and remote) dataset
     * @summary Create Categorized Dataset
     * @param {DatasetInfo} datasetInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public createCategorizedDataset(datasetInfo: DatasetInfo, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).createCategorizedDataset(datasetInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get All Dataset Infos Paginated
     * @param {boolean} [allowEmptyQuery]
     * @param {string} [identifiers]
     * @param {number} [page]
     * @param {string} [query]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getAllDatasetInfos(allowEmptyQuery?: boolean, identifiers?: string, page?: number, query?: string, size?: number, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getAllDatasetInfos(allowEmptyQuery, identifiers, page, query, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all allowed datasets for request user
     * @summary Get Allowed Datasets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getAllowedDatasets(options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getAllowedDatasets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Base Dataset
     * @param {string} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getBaseDataset(identifier: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getBaseDataset(identifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Categories
     * @param {string} [categoryIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getCategories(categoryIds?: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getCategories(categoryIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Company Category Info
     * @param {number} [category]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getCategoryInfo(category?: number, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getCategoryInfo(category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Dataset Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getDatasetCount(options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getDatasetCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all request user company dataset groups
     * @summary Get Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getDatasetGroups(options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getDatasetGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Dataset Info
     * @param {string} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getDatasetInfo(identifier: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getDatasetInfo(identifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all user allowed datasets in DatasetDTO format
     * @summary Get Dataset List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getDatasetList(options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getDatasetList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Datasets By Binding
     * @param {string} id
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getDatasetsByBinding(id: string, type: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getDatasetsByBinding(id, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Datasets By Category
     * @param {number} [categoryId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getDatasetsByCategory(categoryId?: number, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getDatasetsByCategory(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Datasets By Group
     * @param {number} [groupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getDatasetsByGroup(groupId?: number, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getDatasetsByGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Dataset By Tags
     * @param {number} [categoryId]
     * @param {string} [tags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getDatasetsByTags(categoryId?: number, tags?: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getDatasetsByTags(categoryId, tags, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Default Category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getDefaultCategory(options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getDefaultCategory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Datasets
     * @param {DatasetRequestFilter} datasetRequestFilter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getEasasDatasets(datasetRequestFilter: DatasetRequestFilter, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getEasasDatasets(datasetRequestFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get dataset group object by database id
     * @summary Get Group
     * @param {number} groupId Dataset group id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getGroup(groupId: number, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Query Dataset Count
     * @param {boolean} [allowEmptyQuery]
     * @param {string} [identifiers]
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public getQueryDatasetCount(allowEmptyQuery?: boolean, identifiers?: string, query?: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).getQueryDatasetCount(allowEmptyQuery, identifiers, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search datasets by query string
     * @summary Query Datasets
     * @param {boolean} [allowEmptyQuery]
     * @param {string} [identifiers]
     * @param {number} [limit]
     * @param {number} [page]
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public searchDatasets(allowEmptyQuery?: boolean, identifiers?: string, limit?: number, page?: number, query?: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).searchDatasets(allowEmptyQuery, identifiers, limit, page, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Soft Delete Dataset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public softDeleteDataset(id: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).softDeleteDataset(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Dataset Info
     * @param {string} id
     * @param {DatasetInfo} datasetInfo
     * @param {boolean} [fullUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsApi
     */
    public updateDatasetInfo(id: string, datasetInfo: DatasetInfo, fullUpdate?: boolean, options?: RawAxiosRequestConfig) {
        return EASASDatasetsApiFp(this.configuration).updateDatasetInfo(id, datasetInfo, fullUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EASASDatasetsInternalApi - axios parameter creator
 * @export
 */
export const EASASDatasetsInternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete single dataset link from EA-PSM scheme item
         * @summary Delete Link
         * @param {number} linkId Dataset link object to delete
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLink: async (linkId: number, schemeId: string, schemeItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('deleteLink', 'linkId', linkId)
            // verify required parameter 'schemeId' is not null or undefined
            assertParamExists('deleteLink', 'schemeId', schemeId)
            // verify required parameter 'schemeItemId' is not null or undefined
            assertParamExists('deleteLink', 'schemeItemId', schemeItemId)
            const localVarPath = `/rest/easas/datasets/links/delete/{linkId}`
                .replace(`{${"linkId"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (schemeId !== undefined) {
                localVarQueryParameter['schemeId'] = schemeId;
            }

            if (schemeItemId !== undefined) {
                localVarQueryParameter['schemeItemId'] = schemeItemId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme items
         * @summary Get Active Links
         * @param {any} body JsonObject containing EA-PSM scheme UUID and list of EA-PSM scheme item UUIDs to fetch data for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveLinks: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getActiveLinks', 'body', body)
            const localVarPath = `/rest/easas/datasets/activeLinks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
         * @summary Get Link Identifiers
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLinkIdentifiers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/datasets/linkIdentifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme item
         * @summary Get Links
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinks: async (schemeId: string, schemeItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemeId' is not null or undefined
            assertParamExists('getLinks', 'schemeId', schemeId)
            // verify required parameter 'schemeItemId' is not null or undefined
            assertParamExists('getLinks', 'schemeItemId', schemeItemId)
            const localVarPath = `/rest/easas/datasets/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (schemeId !== undefined) {
                localVarQueryParameter['schemeId'] = schemeId;
            }

            if (schemeItemId !== undefined) {
                localVarQueryParameter['schemeItemId'] = schemeItemId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save EA-PSM scheme item dataset link holder to the database
         * @summary Save Scheme Item
         * @param {any} body Dataset link holder object to save
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSchemeItem: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveSchemeItem', 'body', body)
            const localVarPath = `/rest/easas/datasets/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save EA-PSM scheme item single dataset link to the database
         * @summary Update Single Link
         * @param {any} body Dataset link object to save
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSingleLink: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateSingleLink', 'body', body)
            const localVarPath = `/rest/easas/datasets/updateLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EASASDatasetsInternalApi - functional programming interface
 * @export
 */
export const EASASDatasetsInternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EASASDatasetsInternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete single dataset link from EA-PSM scheme item
         * @summary Delete Link
         * @param {number} linkId Dataset link object to delete
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLink(linkId: number, schemeId: string, schemeItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLink(linkId, schemeId, schemeItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsInternalApi.deleteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme items
         * @summary Get Active Links
         * @param {any} body JsonObject containing EA-PSM scheme UUID and list of EA-PSM scheme item UUIDs to fetch data for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveLinks(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveLinks(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsInternalApi.getActiveLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
         * @summary Get Link Identifiers
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getLinkIdentifiers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkIdentifiers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsInternalApi.getLinkIdentifiers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme item
         * @summary Get Links
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinks(schemeId: string, schemeItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinks(schemeId, schemeItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsInternalApi.getLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save EA-PSM scheme item dataset link holder to the database
         * @summary Save Scheme Item
         * @param {any} body Dataset link holder object to save
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSchemeItem(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSchemeItem(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsInternalApi.saveSchemeItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save EA-PSM scheme item single dataset link to the database
         * @summary Update Single Link
         * @param {any} body Dataset link object to save
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSingleLink(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSingleLink(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EASASDatasetsInternalApi.updateSingleLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EASASDatasetsInternalApi - factory interface
 * @export
 */
export const EASASDatasetsInternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EASASDatasetsInternalApiFp(configuration)
    return {
        /**
         * Delete single dataset link from EA-PSM scheme item
         * @summary Delete Link
         * @param {number} linkId Dataset link object to delete
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLink(linkId: number, schemeId: string, schemeItemId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteLink(linkId, schemeId, schemeItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme items
         * @summary Get Active Links
         * @param {any} body JsonObject containing EA-PSM scheme UUID and list of EA-PSM scheme item UUIDs to fetch data for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveLinks(body: any, options?: RawAxiosRequestConfig): AxiosPromise<Array<any>> {
            return localVarFp.getActiveLinks(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
         * @summary Get Link Identifiers
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLinkIdentifiers(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getLinkIdentifiers(options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme item
         * @summary Get Links
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinks(schemeId: string, schemeItemId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<any>> {
            return localVarFp.getLinks(schemeId, schemeItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Save EA-PSM scheme item dataset link holder to the database
         * @summary Save Scheme Item
         * @param {any} body Dataset link holder object to save
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSchemeItem(body: any, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.saveSchemeItem(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Save EA-PSM scheme item single dataset link to the database
         * @summary Update Single Link
         * @param {any} body Dataset link object to save
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSingleLink(body: any, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateSingleLink(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EASASDatasetsInternalApi - object-oriented interface
 * @export
 * @class EASASDatasetsInternalApi
 * @extends {BaseAPI}
 */
export class EASASDatasetsInternalApi extends BaseAPI {
    /**
     * Delete single dataset link from EA-PSM scheme item
     * @summary Delete Link
     * @param {number} linkId Dataset link object to delete
     * @param {string} schemeId EA-PSM scheme UUID
     * @param {string} schemeItemId EA-PSM scheme item UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsInternalApi
     */
    public deleteLink(linkId: number, schemeId: string, schemeItemId: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsInternalApiFp(this.configuration).deleteLink(linkId, schemeId, schemeItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get dataset links that are assigned to given EA-PSM scheme items
     * @summary Get Active Links
     * @param {any} body JsonObject containing EA-PSM scheme UUID and list of EA-PSM scheme item UUIDs to fetch data for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsInternalApi
     */
    public getActiveLinks(body: any, options?: RawAxiosRequestConfig) {
        return EASASDatasetsInternalApiFp(this.configuration).getActiveLinks(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
     * @summary Get Link Identifiers
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EASASDatasetsInternalApi
     */
    public getLinkIdentifiers(options?: RawAxiosRequestConfig) {
        return EASASDatasetsInternalApiFp(this.configuration).getLinkIdentifiers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get dataset links that are assigned to given EA-PSM scheme item
     * @summary Get Links
     * @param {string} schemeId EA-PSM scheme UUID
     * @param {string} schemeItemId EA-PSM scheme item UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsInternalApi
     */
    public getLinks(schemeId: string, schemeItemId: string, options?: RawAxiosRequestConfig) {
        return EASASDatasetsInternalApiFp(this.configuration).getLinks(schemeId, schemeItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save EA-PSM scheme item dataset link holder to the database
     * @summary Save Scheme Item
     * @param {any} body Dataset link holder object to save
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsInternalApi
     */
    public saveSchemeItem(body: any, options?: RawAxiosRequestConfig) {
        return EASASDatasetsInternalApiFp(this.configuration).saveSchemeItem(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save EA-PSM scheme item single dataset link to the database
     * @summary Update Single Link
     * @param {any} body Dataset link object to save
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EASASDatasetsInternalApi
     */
    public updateSingleLink(body: any, options?: RawAxiosRequestConfig) {
        return EASASDatasetsInternalApiFp(this.configuration).updateSingleLink(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/health/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.health']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async version(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.version(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.version']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         *
         * @summary Get Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.version(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     *
     * @summary Get Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public health(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public version(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).version(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InfoApi - axios parameter creator
 * @export
 */
export const InfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Time Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restInfoTimeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/info/time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoApi - functional programming interface
 * @export
 */
export const InfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Time Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restInfoTimeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restInfoTimeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InfoApi.restInfoTimeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InfoApi - factory interface
 * @export
 */
export const InfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoApiFp(configuration)
    return {
        /**
         *
         * @summary Get Time Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restInfoTimeGet(options?: RawAxiosRequestConfig): AxiosPromise<TimeInfo> {
            return localVarFp.restInfoTimeGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InfoApi - object-oriented interface
 * @export
 * @class InfoApi
 * @extends {BaseAPI}
 */
export class InfoApi extends BaseAPI {
    /**
     *
     * @summary Get Time Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoApi
     */
    public restInfoTimeGet(options?: RawAxiosRequestConfig) {
        return InfoApiFp(this.configuration).restInfoTimeGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LogsApi - axios parameter creator
 * @export
 */
export const LogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get log of data collector instance
         * @summary Get General Log
         * @param {LogRequest} logRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralLog: async (logRequest: LogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logRequest' is not null or undefined
            assertParamExists('getGeneralLog', 'logRequest', logRequest)
            const localVarPath = `/rest/logs/general`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get log of reader. Any provided \"loggerNameRegex\" is ignored
         * @summary Get Reader Log
         * @param {string} readerId
         * @param {LogRequest} logRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderLog: async (readerId: string, logRequest: LogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('getReaderLog', 'readerId', readerId)
            // verify required parameter 'logRequest' is not null or undefined
            assertParamExists('getReaderLog', 'logRequest', logRequest)
            const localVarPath = `/rest/logs/reader/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Truncate logs to free up space
         * @summary Truncate Log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truncateLog: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/logs/truncate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogsApi - functional programming interface
 * @export
 */
export const LogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get log of data collector instance
         * @summary Get General Log
         * @param {LogRequest} logRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralLog(logRequest: LogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralLog(logRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.getGeneralLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get log of reader. Any provided \"loggerNameRegex\" is ignored
         * @summary Get Reader Log
         * @param {string} readerId
         * @param {LogRequest} logRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReaderLog(readerId: string, logRequest: LogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReaderLog(readerId, logRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.getReaderLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Truncate logs to free up space
         * @summary Truncate Log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truncateLog(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truncateLog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.truncateLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogsApi - factory interface
 * @export
 */
export const LogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogsApiFp(configuration)
    return {
        /**
         * Get log of data collector instance
         * @summary Get General Log
         * @param {LogRequest} logRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralLog(logRequest: LogRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LogMessage>> {
            return localVarFp.getGeneralLog(logRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get log of reader. Any provided \"loggerNameRegex\" is ignored
         * @summary Get Reader Log
         * @param {string} readerId
         * @param {LogRequest} logRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderLog(readerId: string, logRequest: LogRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LogMessage>> {
            return localVarFp.getReaderLog(readerId, logRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Truncate logs to free up space
         * @summary Truncate Log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truncateLog(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.truncateLog(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogsApi - object-oriented interface
 * @export
 * @class LogsApi
 * @extends {BaseAPI}
 */
export class LogsApi extends BaseAPI {
    /**
     * Get log of data collector instance
     * @summary Get General Log
     * @param {LogRequest} logRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public getGeneralLog(logRequest: LogRequest, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).getGeneralLog(logRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get log of reader. Any provided \"loggerNameRegex\" is ignored
     * @summary Get Reader Log
     * @param {string} readerId
     * @param {LogRequest} logRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public getReaderLog(readerId: string, logRequest: LogRequest, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).getReaderLog(readerId, logRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Truncate logs to free up space
     * @summary Truncate Log
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public truncateLog(options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).truncateLog(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ManagementApi - axios parameter creator
 * @export
 */
export const ManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Empty Config
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmptyConfig: async (schema: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('createEmptyConfig', 'schema', schema)
            const localVarPath = `/rest/management/emptyConfig/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Reader
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReader: async (readerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('deleteReader', 'readerId', readerId)
            const localVarPath = `/rest/management/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Does Reader Exist
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesReaderExist: async (readerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('doesReaderExist', 'readerId', readerId)
            const localVarPath = `/rest/management/exists/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get All Schemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReaderSchemas: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/management/allSchemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get General Config
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralConfig: async (readerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('getGeneralConfig', 'readerId', readerId)
            const localVarPath = `/rest/management/{readerId}/general`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Global Deduplication Config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalDeduplicationConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/management/globalDeduplicationConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Meter Config
         * @param {string} meterId
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterConfig: async (meterId: string, readerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meterId' is not null or undefined
            assertParamExists('getMeterConfig', 'meterId', meterId)
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('getMeterConfig', 'readerId', readerId)
            const localVarPath = `/rest/management/{readerId}/meter/{meterId}`
                .replace(`{${"meterId"}}`, encodeURIComponent(String(meterId)))
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Reader Config
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderConfig: async (readerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('getReaderConfig', 'readerId', readerId)
            const localVarPath = `/rest/management/config/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Reader Config Editor
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderConfigEditor: async (readerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('getReaderConfigEditor', 'readerId', readerId)
            const localVarPath = `/rest/management/configEditor/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Schema
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderSchema: async (schema: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getReaderSchema', 'schema', schema)
            const localVarPath = `/rest/management/schema/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Supported Meter Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedMeterTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/management/supportedMeterTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Parse Config
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseConfig: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('parseConfig', 'body', body)
            const localVarPath = `/rest/management/parseConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reload All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/management/reloadAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reload Reader
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadReader: async (readerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('reloadReader', 'readerId', readerId)
            const localVarPath = `/rest/management/reload/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set Global Deduplication Config
         * @param {GlobalDeduplicationConfig} globalDeduplicationConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGlobalDeduplicationConfig: async (globalDeduplicationConfig: GlobalDeduplicationConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'globalDeduplicationConfig' is not null or undefined
            assertParamExists('setGlobalDeduplicationConfig', 'globalDeduplicationConfig', globalDeduplicationConfig)
            const localVarPath = `/rest/management/globalDeduplicationConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(globalDeduplicationConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set Reader Config
         * @param {string} readerId
         * @param {any} body
         * @param {string} [expectedModifiedTs]
         * @param {boolean} [requireExist]
         * @param {boolean} [requireNotExist]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setReaderConfig: async (readerId: string, body: any, expectedModifiedTs?: string, requireExist?: boolean, requireNotExist?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('setReaderConfig', 'readerId', readerId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setReaderConfig', 'body', body)
            const localVarPath = `/rest/management/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (expectedModifiedTs !== undefined) {
                localVarQueryParameter['expectedModifiedTs'] = (expectedModifiedTs as any instanceof Date) ?
                    (expectedModifiedTs as any).toISOString() :
                    expectedModifiedTs;
            }

            if (requireExist !== undefined) {
                localVarQueryParameter['requireExist'] = requireExist;
            }

            if (requireNotExist !== undefined) {
                localVarQueryParameter['requireNotExist'] = requireNotExist;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Shutdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shutdownDatacollector: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/management/shutdownDatacollector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagementApi - functional programming interface
 * @export
 */
export const ManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManagementApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Empty Config
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmptyConfig(schema: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmptyConfig(schema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.createEmptyConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Reader
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReader(readerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReader(readerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.deleteReader']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Does Reader Exist
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doesReaderExist(readerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doesReaderExist(readerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.doesReaderExist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get All Schemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReaderSchemas(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReaderSchemas(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getAllReaderSchemas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get General Config
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralConfig(readerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralConfig(readerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getGeneralConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Global Deduplication Config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGlobalDeduplicationConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalDeduplicationConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGlobalDeduplicationConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getGlobalDeduplicationConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Meter Config
         * @param {string} meterId
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeterConfig(meterId: string, readerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeterConfig(meterId, readerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getMeterConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Reader Config
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReaderConfig(readerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReaderConfig(readerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getReaderConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Reader Config Editor
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReaderConfigEditor(readerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReaderConfigEditor(readerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getReaderConfigEditor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Schema
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReaderSchema(schema: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReaderSchema(schema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getReaderSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Supported Meter Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedMeterTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProtocolDescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedMeterTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getSupportedMeterTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Parse Config
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseConfig(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasicReaderInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseConfig(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.parseConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Reload All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reloadAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reloadAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.reloadAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Reload Reader
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reloadReader(readerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reloadReader(readerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.reloadReader']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Set Global Deduplication Config
         * @param {GlobalDeduplicationConfig} globalDeduplicationConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setGlobalDeduplicationConfig(globalDeduplicationConfig: GlobalDeduplicationConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setGlobalDeduplicationConfig(globalDeduplicationConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.setGlobalDeduplicationConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Set Reader Config
         * @param {string} readerId
         * @param {any} body
         * @param {string} [expectedModifiedTs]
         * @param {boolean} [requireExist]
         * @param {boolean} [requireNotExist]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setReaderConfig(readerId: string, body: any, expectedModifiedTs?: string, requireExist?: boolean, requireNotExist?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setReaderConfig(readerId, body, expectedModifiedTs, requireExist, requireNotExist, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.setReaderConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Shutdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shutdownDatacollector(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shutdownDatacollector(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.shutdownDatacollector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManagementApi - factory interface
 * @export
 */
export const ManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManagementApiFp(configuration)
    return {
        /**
         *
         * @summary Create Empty Config
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmptyConfig(schema: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createEmptyConfig(schema, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Reader
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReader(readerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteReader(readerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Does Reader Exist
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesReaderExist(readerId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.doesReaderExist(readerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get All Schemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReaderSchemas(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getAllReaderSchemas(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get General Config
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralConfig(readerId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getGeneralConfig(readerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Global Deduplication Config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalDeduplicationConfig(options?: RawAxiosRequestConfig): AxiosPromise<GlobalDeduplicationConfig> {
            return localVarFp.getGlobalDeduplicationConfig(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Meter Config
         * @param {string} meterId
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterConfig(meterId: string, readerId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getMeterConfig(meterId, readerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Reader Config
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderConfig(readerId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getReaderConfig(readerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Reader Config Editor
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderConfigEditor(readerId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserInfo> {
            return localVarFp.getReaderConfigEditor(readerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Schema
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderSchema(schema: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getReaderSchema(schema, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Supported Meter Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedMeterTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProtocolDescription>> {
            return localVarFp.getSupportedMeterTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Parse Config
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseConfig(body: string, options?: RawAxiosRequestConfig): AxiosPromise<BasicReaderInfo> {
            return localVarFp.parseConfig(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reload All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadAll(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reloadAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reload Reader
         * @param {string} readerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadReader(readerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reloadReader(readerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set Global Deduplication Config
         * @param {GlobalDeduplicationConfig} globalDeduplicationConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGlobalDeduplicationConfig(globalDeduplicationConfig: GlobalDeduplicationConfig, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setGlobalDeduplicationConfig(globalDeduplicationConfig, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set Reader Config
         * @param {string} readerId
         * @param {any} body
         * @param {string} [expectedModifiedTs]
         * @param {boolean} [requireExist]
         * @param {boolean} [requireNotExist]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setReaderConfig(readerId: string, body: any, expectedModifiedTs?: string, requireExist?: boolean, requireNotExist?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.setReaderConfig(readerId, body, expectedModifiedTs, requireExist, requireNotExist, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Shutdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shutdownDatacollector(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.shutdownDatacollector(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ManagementApi - object-oriented interface
 * @export
 * @class ManagementApi
 * @extends {BaseAPI}
 */
export class ManagementApi extends BaseAPI {
    /**
     *
     * @summary Create Empty Config
     * @param {string} schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public createEmptyConfig(schema: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).createEmptyConfig(schema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Reader
     * @param {string} readerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public deleteReader(readerId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).deleteReader(readerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Does Reader Exist
     * @param {string} readerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public doesReaderExist(readerId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).doesReaderExist(readerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get All Schemas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getAllReaderSchemas(options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getAllReaderSchemas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get General Config
     * @param {string} readerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getGeneralConfig(readerId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getGeneralConfig(readerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Global Deduplication Config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getGlobalDeduplicationConfig(options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getGlobalDeduplicationConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Meter Config
     * @param {string} meterId
     * @param {string} readerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getMeterConfig(meterId: string, readerId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getMeterConfig(meterId, readerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Reader Config
     * @param {string} readerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getReaderConfig(readerId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getReaderConfig(readerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Reader Config Editor
     * @param {string} readerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getReaderConfigEditor(readerId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getReaderConfigEditor(readerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Schema
     * @param {string} schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getReaderSchema(schema: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getReaderSchema(schema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Supported Meter Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getSupportedMeterTypes(options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getSupportedMeterTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Parse Config
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public parseConfig(body: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).parseConfig(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Reload All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public reloadAll(options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).reloadAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Reload Reader
     * @param {string} readerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public reloadReader(readerId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).reloadReader(readerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set Global Deduplication Config
     * @param {GlobalDeduplicationConfig} globalDeduplicationConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public setGlobalDeduplicationConfig(globalDeduplicationConfig: GlobalDeduplicationConfig, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).setGlobalDeduplicationConfig(globalDeduplicationConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set Reader Config
     * @param {string} readerId
     * @param {any} body
     * @param {string} [expectedModifiedTs]
     * @param {boolean} [requireExist]
     * @param {boolean} [requireNotExist]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public setReaderConfig(readerId: string, body: any, expectedModifiedTs?: string, requireExist?: boolean, requireNotExist?: boolean, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).setReaderConfig(readerId, body, expectedModifiedTs, requireExist, requireNotExist, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Shutdown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public shutdownDatacollector(options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).shutdownDatacollector(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeasurementApi - axios parameter creator
 * @export
 */
export const MeasurementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get latest measurements
         * @summary Get Latest Measurements
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestMeasurements: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getLatestMeasurements', 'requestBody', requestBody)
            const localVarPath = `/rest/measurements/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get measurements of a many meters
         * @summary Get Meter Measurements
         * @param {MeasurementRequest} measurementRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetersMeasurements: async (measurementRequest: MeasurementRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementRequest' is not null or undefined
            assertParamExists('getMetersMeasurements', 'measurementRequest', measurementRequest)
            const localVarPath = `/rest/measurements/meters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(measurementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get measurements of a many meters
         * @summary Get Meters Measurements
         * @param {Array<string>} [aMeters] Meters
         * @param {number} [cFrom] Unix instant in milliseconds from which to get measurements
         * @param {number} [dTo] Unix instant in milliseconds to which to get measurements
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getMetersMeasurementsDeprecated: async (aMeters?: Array<string>, cFrom?: number, dTo?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/measurements/meters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aMeters) {
                localVarQueryParameter['a_meters'] = aMeters;
            }

            if (cFrom !== undefined) {
                localVarQueryParameter['c_from'] = cFrom;
            }

            if (dTo !== undefined) {
                localVarQueryParameter['d_to'] = dTo;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product items
         * @summary Get Product Items
         * @param {ProductRequest} productRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductItems: async (productRequest: ProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productRequest' is not null or undefined
            assertParamExists('getProductItems', 'productRequest', productRequest)
            const localVarPath = `/rest/measurements/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementApi - functional programming interface
 * @export
 */
export const MeasurementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementApiAxiosParamCreator(configuration)
    return {
        /**
         * Get latest measurements
         * @summary Get Latest Measurements
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestMeasurements(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Measurement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestMeasurements(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.getLatestMeasurements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get measurements of a many meters
         * @summary Get Meter Measurements
         * @param {MeasurementRequest} measurementRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetersMeasurements(measurementRequest: MeasurementRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Measurement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetersMeasurements(measurementRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.getMetersMeasurements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get measurements of a many meters
         * @summary Get Meters Measurements
         * @param {Array<string>} [aMeters] Meters
         * @param {number} [cFrom] Unix instant in milliseconds from which to get measurements
         * @param {number} [dTo] Unix instant in milliseconds to which to get measurements
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getMetersMeasurementsDeprecated(aMeters?: Array<string>, cFrom?: number, dTo?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Measurement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetersMeasurementsDeprecated(aMeters, cFrom, dTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.getMetersMeasurementsDeprecated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get product items
         * @summary Get Product Items
         * @param {ProductRequest} productRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductItems(productRequest: ProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductItems(productRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.getProductItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementApi - factory interface
 * @export
 */
export const MeasurementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementApiFp(configuration)
    return {
        /**
         * Get latest measurements
         * @summary Get Latest Measurements
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestMeasurements(requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<Measurement>> {
            return localVarFp.getLatestMeasurements(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get measurements of a many meters
         * @summary Get Meter Measurements
         * @param {MeasurementRequest} measurementRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetersMeasurements(measurementRequest: MeasurementRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Measurement>> {
            return localVarFp.getMetersMeasurements(measurementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get measurements of a many meters
         * @summary Get Meters Measurements
         * @param {Array<string>} [aMeters] Meters
         * @param {number} [cFrom] Unix instant in milliseconds from which to get measurements
         * @param {number} [dTo] Unix instant in milliseconds to which to get measurements
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getMetersMeasurementsDeprecated(aMeters?: Array<string>, cFrom?: number, dTo?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Measurement>> {
            return localVarFp.getMetersMeasurementsDeprecated(aMeters, cFrom, dTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Get product items
         * @summary Get Product Items
         * @param {ProductRequest} productRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductItems(productRequest: ProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductItem>> {
            return localVarFp.getProductItems(productRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementApi - object-oriented interface
 * @export
 * @class MeasurementApi
 * @extends {BaseAPI}
 */
export class MeasurementApi extends BaseAPI {
    /**
     * Get latest measurements
     * @summary Get Latest Measurements
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementApi
     */
    public getLatestMeasurements(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).getLatestMeasurements(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get measurements of a many meters
     * @summary Get Meter Measurements
     * @param {MeasurementRequest} measurementRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementApi
     */
    public getMetersMeasurements(measurementRequest: MeasurementRequest, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).getMetersMeasurements(measurementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get measurements of a many meters
     * @summary Get Meters Measurements
     * @param {Array<string>} [aMeters] Meters
     * @param {number} [cFrom] Unix instant in milliseconds from which to get measurements
     * @param {number} [dTo] Unix instant in milliseconds to which to get measurements
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MeasurementApi
     */
    public getMetersMeasurementsDeprecated(aMeters?: Array<string>, cFrom?: number, dTo?: number, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).getMetersMeasurementsDeprecated(aMeters, cFrom, dTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get product items
     * @summary Get Product Items
     * @param {ProductRequest} productRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeasurementApi
     */
    public getProductItems(productRequest: ProductRequest, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).getProductItems(productRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OPCUAApi - axios parameter creator
 * @export
 */
export const OPCUAApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upload a client application certificate (DER or PEM) and trust it immediately
         * @summary Add Trusted
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTrustedOpcUaCertificate: async (body: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addTrustedOpcUaCertificate', 'body', body)
            const localVarPath = `/rest/opcua/certificates/trusted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/octet-stream';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue an X.509 user identity; returns a zip with <username>_cert.der and <username>_key.pem
         * @summary Create X 509 User
         * @param {OpcUaX509UserRequest} opcUaX509UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpcUaX509User: async (opcUaX509UserRequest: OpcUaX509UserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opcUaX509UserRequest' is not null or undefined
            assertParamExists('createOpcUaX509User', 'opcUaX509UserRequest', opcUaX509UserRequest)
            const localVarPath = `/rest/opcua/users/x509`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opcUaX509UserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a certificate entirely
         * @summary Delete Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpcUaCertificate: async (thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('deleteOpcUaCertificate', 'thumbprint', thumbprint)
            const localVarPath = `/rest/opcua/certificates/{thumbprint}`
                .replace(`{${"thumbprint"}}`, encodeURIComponent(String(thumbprint)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a username/password account
         * @summary Delete User
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpcUaUser: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('deleteOpcUaUser', 'username', username)
            const localVarPath = `/rest/opcua/users/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a certificate in DER form
         * @summary Download Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOpcUaCertificate: async (thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('downloadOpcUaCertificate', 'thumbprint', thumbprint)
            const localVarPath = `/rest/opcua/certificates/{thumbprint}`
                .replace(`{${"thumbprint"}}`, encodeURIComponent(String(thumbprint)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List certificates; optionally filtered by kind (TRUSTED_APP, ISSUER, USER, REJECTED)
         * @summary Get Certificates
         * @param {string} [kind]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpcUaCertificates: async (kind?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/opcua/certificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List OPC UA username/password accounts
         * @summary Get Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpcUaUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/opcua/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register an existing certificate (DER or PEM) as an X.509 user identity
         * @summary Import X 509 User
         * @param {File} body
         * @param {string} [username]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importOpcUaX509User: async (body: File, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('importOpcUaX509User', 'body', body)
            const localVarPath = `/rest/opcua/users/x509/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }



            localVarHeaderParameter['Content-Type'] = 'application/octet-stream';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or replace a username/password account
         * @summary Put User
         * @param {string} username
         * @param {OpcUaUserRequest} opcUaUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOpcUaUser: async (username: string, opcUaUserRequest: OpcUaUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('putOpcUaUser', 'username', username)
            // verify required parameter 'opcUaUserRequest' is not null or undefined
            assertParamExists('putOpcUaUser', 'opcUaUserRequest', opcUaUserRequest)
            const localVarPath = `/rest/opcua/users/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opcUaUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a certificate, keeping the row for audit purposes
         * @summary Revoke Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeOpcUaCertificate: async (thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('revokeOpcUaCertificate', 'thumbprint', thumbprint)
            const localVarPath = `/rest/opcua/certificates/{thumbprint}/revoke`
                .replace(`{${"thumbprint"}}`, encodeURIComponent(String(thumbprint)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable an account
         * @summary Set User Enabled
         * @param {string} username
         * @param {boolean} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpcUaUserEnabled: async (username: string, value?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('setOpcUaUserEnabled', 'username', username)
            const localVarPath = `/rest/opcua/users/{username}/enabled`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change an account\'s password
         * @summary Set Password
         * @param {string} username
         * @param {OpcUaUserRequest} opcUaUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpcUaUserPassword: async (username: string, opcUaUserRequest: OpcUaUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('setOpcUaUserPassword', 'username', username)
            // verify required parameter 'opcUaUserRequest' is not null or undefined
            assertParamExists('setOpcUaUserPassword', 'opcUaUserRequest', opcUaUserRequest)
            const localVarPath = `/rest/opcua/users/{username}/password`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opcUaUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow a client application certificate, typically one that was rejected on a previous connection
         * @summary Trust Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trustOpcUaCertificate: async (thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('trustOpcUaCertificate', 'thumbprint', thumbprint)
            const localVarPath = `/rest/opcua/certificates/{thumbprint}/trust`
                .replace(`{${"thumbprint"}}`, encodeURIComponent(String(thumbprint)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OPCUAApi - functional programming interface
 * @export
 */
export const OPCUAApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OPCUAApiAxiosParamCreator(configuration)
    return {
        /**
         * Upload a client application certificate (DER or PEM) and trust it immediately
         * @summary Add Trusted
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTrustedOpcUaCertificate(body: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpcUaCertificateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTrustedOpcUaCertificate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.addTrustedOpcUaCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue an X.509 user identity; returns a zip with <username>_cert.der and <username>_key.pem
         * @summary Create X 509 User
         * @param {OpcUaX509UserRequest} opcUaX509UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOpcUaX509User(opcUaX509UserRequest: OpcUaX509UserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOpcUaX509User(opcUaX509UserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.createOpcUaX509User']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a certificate entirely
         * @summary Delete Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOpcUaCertificate(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.deleteOpcUaCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a username/password account
         * @summary Delete User
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOpcUaUser(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOpcUaUser(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.deleteOpcUaUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a certificate in DER form
         * @summary Download Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOpcUaCertificate(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.downloadOpcUaCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List certificates; optionally filtered by kind (TRUSTED_APP, ISSUER, USER, REJECTED)
         * @summary Get Certificates
         * @param {string} [kind]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpcUaCertificates(kind?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpcUaCertificateDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpcUaCertificates(kind, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.getOpcUaCertificates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List OPC UA username/password accounts
         * @summary Get Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpcUaUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpcUaUserDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpcUaUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.getOpcUaUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register an existing certificate (DER or PEM) as an X.509 user identity
         * @summary Import X 509 User
         * @param {File} body
         * @param {string} [username]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importOpcUaX509User(body: File, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpcUaCertificateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importOpcUaX509User(body, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.importOpcUaX509User']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or replace a username/password account
         * @summary Put User
         * @param {string} username
         * @param {OpcUaUserRequest} opcUaUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOpcUaUser(username: string, opcUaUserRequest: OpcUaUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOpcUaUser(username, opcUaUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.putOpcUaUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a certificate, keeping the row for audit purposes
         * @summary Revoke Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeOpcUaCertificate(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.revokeOpcUaCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable or disable an account
         * @summary Set User Enabled
         * @param {string} username
         * @param {boolean} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOpcUaUserEnabled(username: string, value?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOpcUaUserEnabled(username, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.setOpcUaUserEnabled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change an account\'s password
         * @summary Set Password
         * @param {string} username
         * @param {OpcUaUserRequest} opcUaUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOpcUaUserPassword(username: string, opcUaUserRequest: OpcUaUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOpcUaUserPassword(username, opcUaUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.setOpcUaUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allow a client application certificate, typically one that was rejected on a previous connection
         * @summary Trust Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trustOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trustOpcUaCertificate(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OPCUAApi.trustOpcUaCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OPCUAApi - factory interface
 * @export
 */
export const OPCUAApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OPCUAApiFp(configuration)
    return {
        /**
         * Upload a client application certificate (DER or PEM) and trust it immediately
         * @summary Add Trusted
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTrustedOpcUaCertificate(body: File, options?: RawAxiosRequestConfig): AxiosPromise<OpcUaCertificateDTO> {
            return localVarFp.addTrustedOpcUaCertificate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Issue an X.509 user identity; returns a zip with <username>_cert.der and <username>_key.pem
         * @summary Create X 509 User
         * @param {OpcUaX509UserRequest} opcUaX509UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpcUaX509User(opcUaX509UserRequest: OpcUaX509UserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createOpcUaX509User(opcUaX509UserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a certificate entirely
         * @summary Delete Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOpcUaCertificate(thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a username/password account
         * @summary Delete User
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOpcUaUser(username: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOpcUaUser(username, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a certificate in DER form
         * @summary Download Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadOpcUaCertificate(thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * List certificates; optionally filtered by kind (TRUSTED_APP, ISSUER, USER, REJECTED)
         * @summary Get Certificates
         * @param {string} [kind]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpcUaCertificates(kind?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OpcUaCertificateDTO>> {
            return localVarFp.getOpcUaCertificates(kind, options).then((request) => request(axios, basePath));
        },
        /**
         * List OPC UA username/password accounts
         * @summary Get Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpcUaUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<OpcUaUserDTO>> {
            return localVarFp.getOpcUaUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Register an existing certificate (DER or PEM) as an X.509 user identity
         * @summary Import X 509 User
         * @param {File} body
         * @param {string} [username]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importOpcUaX509User(body: File, username?: string, options?: RawAxiosRequestConfig): AxiosPromise<OpcUaCertificateDTO> {
            return localVarFp.importOpcUaX509User(body, username, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or replace a username/password account
         * @summary Put User
         * @param {string} username
         * @param {OpcUaUserRequest} opcUaUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOpcUaUser(username: string, opcUaUserRequest: OpcUaUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putOpcUaUser(username, opcUaUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a certificate, keeping the row for audit purposes
         * @summary Revoke Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeOpcUaCertificate(thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable an account
         * @summary Set User Enabled
         * @param {string} username
         * @param {boolean} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpcUaUserEnabled(username: string, value?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setOpcUaUserEnabled(username, value, options).then((request) => request(axios, basePath));
        },
        /**
         * Change an account\'s password
         * @summary Set Password
         * @param {string} username
         * @param {OpcUaUserRequest} opcUaUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpcUaUserPassword(username: string, opcUaUserRequest: OpcUaUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setOpcUaUserPassword(username, opcUaUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow a client application certificate, typically one that was rejected on a previous connection
         * @summary Trust Certificate
         * @param {string} thumbprint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trustOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.trustOpcUaCertificate(thumbprint, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OPCUAApi - object-oriented interface
 * @export
 * @class OPCUAApi
 * @extends {BaseAPI}
 */
export class OPCUAApi extends BaseAPI {
    /**
     * Upload a client application certificate (DER or PEM) and trust it immediately
     * @summary Add Trusted
     * @param {File} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public addTrustedOpcUaCertificate(body: File, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).addTrustedOpcUaCertificate(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue an X.509 user identity; returns a zip with <username>_cert.der and <username>_key.pem
     * @summary Create X 509 User
     * @param {OpcUaX509UserRequest} opcUaX509UserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public createOpcUaX509User(opcUaX509UserRequest: OpcUaX509UserRequest, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).createOpcUaX509User(opcUaX509UserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a certificate entirely
     * @summary Delete Certificate
     * @param {string} thumbprint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public deleteOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).deleteOpcUaCertificate(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a username/password account
     * @summary Delete User
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public deleteOpcUaUser(username: string, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).deleteOpcUaUser(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a certificate in DER form
     * @summary Download Certificate
     * @param {string} thumbprint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public downloadOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).downloadOpcUaCertificate(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List certificates; optionally filtered by kind (TRUSTED_APP, ISSUER, USER, REJECTED)
     * @summary Get Certificates
     * @param {string} [kind]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public getOpcUaCertificates(kind?: string, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).getOpcUaCertificates(kind, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List OPC UA username/password accounts
     * @summary Get Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public getOpcUaUsers(options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).getOpcUaUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register an existing certificate (DER or PEM) as an X.509 user identity
     * @summary Import X 509 User
     * @param {File} body
     * @param {string} [username]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public importOpcUaX509User(body: File, username?: string, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).importOpcUaX509User(body, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or replace a username/password account
     * @summary Put User
     * @param {string} username
     * @param {OpcUaUserRequest} opcUaUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public putOpcUaUser(username: string, opcUaUserRequest: OpcUaUserRequest, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).putOpcUaUser(username, opcUaUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a certificate, keeping the row for audit purposes
     * @summary Revoke Certificate
     * @param {string} thumbprint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public revokeOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).revokeOpcUaCertificate(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable an account
     * @summary Set User Enabled
     * @param {string} username
     * @param {boolean} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public setOpcUaUserEnabled(username: string, value?: boolean, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).setOpcUaUserEnabled(username, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change an account\'s password
     * @summary Set Password
     * @param {string} username
     * @param {OpcUaUserRequest} opcUaUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public setOpcUaUserPassword(username: string, opcUaUserRequest: OpcUaUserRequest, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).setOpcUaUserPassword(username, opcUaUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow a client application certificate, typically one that was rejected on a previous connection
     * @summary Trust Certificate
     * @param {string} thumbprint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OPCUAApi
     */
    public trustOpcUaCertificate(thumbprint: string, options?: RawAxiosRequestConfig) {
        return OPCUAApiFp(this.configuration).trustOpcUaCertificate(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObjectApi - axios parameter creator
 * @export
 */
export const ObjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get All Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/objects/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Readers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/objects/readers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Tags
         * @param {string} aReader
         * @param {string} bMeter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsMeter: async (aReader: string, bMeter: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aReader' is not null or undefined
            assertParamExists('getTagsMeter', 'aReader', aReader)
            // verify required parameter 'bMeter' is not null or undefined
            assertParamExists('getTagsMeter', 'bMeter', bMeter)
            const localVarPath = `/rest/objects/tags/{a_reader}/{b_meter}`
                .replace(`{${"a_reader"}}`, encodeURIComponent(String(aReader)))
                .replace(`{${"b_meter"}}`, encodeURIComponent(String(bMeter)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Tags
         * @param {string} reader
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsReader: async (reader: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reader' is not null or undefined
            assertParamExists('getTagsReader', 'reader', reader)
            const localVarPath = `/rest/objects/tags/{reader}`
                .replace(`{${"reader"}}`, encodeURIComponent(String(reader)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObjectApi - functional programming interface
 * @export
 */
export const ObjectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObjectApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get All Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.getAllTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Readers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReaders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasicReaderInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReaders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.getReaders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Tags
         * @param {string} aReader
         * @param {string} bMeter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagsMeter(aReader: string, bMeter: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagsMeter(aReader, bMeter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.getTagsMeter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Tags
         * @param {string} reader
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagsReader(reader: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagsReader(reader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.getTagsReader']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObjectApi - factory interface
 * @export
 */
export const ObjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObjectApiFp(configuration)
    return {
        /**
         *
         * @summary Get All Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTags(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAllTags(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Readers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaders(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasicReaderInfo>> {
            return localVarFp.getReaders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Tags
         * @param {string} aReader
         * @param {string} bMeter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsMeter(aReader: string, bMeter: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getTagsMeter(aReader, bMeter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Tags
         * @param {string} reader
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsReader(reader: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getTagsReader(reader, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObjectApi - object-oriented interface
 * @export
 * @class ObjectApi
 * @extends {BaseAPI}
 */
export class ObjectApi extends BaseAPI {
    /**
     *
     * @summary Get All Tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectApi
     */
    public getAllTags(options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).getAllTags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Readers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectApi
     */
    public getReaders(options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).getReaders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Tags
     * @param {string} aReader
     * @param {string} bMeter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectApi
     */
    public getTagsMeter(aReader: string, bMeter: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).getTagsMeter(aReader, bMeter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Tags
     * @param {string} reader
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectApi
     */
    public getTagsReader(reader: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).getTagsReader(reader, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PostprocessorApi - axios parameter creator
 * @export
 */
export const PostprocessorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Delete postprocessor config by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfig: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteConfig', 'id', id)
            const localVarPath = `/rest/postprocessors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all postprocessor configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConfigs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/postprocessors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get All Schemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPostProcessorSchemas: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/postprocessors/allSchemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get postprocessor config by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getConfig', 'id', id)
            const localVarPath = `/rest/postprocessors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Schema
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostProcessorSchema: async (schema: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getPostProcessorSchema', 'schema', schema)
            const localVarPath = `/rest/postprocessors/schema/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Supported Post Processors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedPostProcessors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/postprocessors/supportedPostprocessors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set postprocessor config by id
         * @param {PostProcessorConfigDTO} postProcessorConfigDTO
         * @param {boolean} [restartReaders]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConfig: async (postProcessorConfigDTO: PostProcessorConfigDTO, restartReaders?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postProcessorConfigDTO' is not null or undefined
            assertParamExists('setConfig', 'postProcessorConfigDTO', postProcessorConfigDTO)
            const localVarPath = `/rest/postprocessors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (restartReaders !== undefined) {
                localVarQueryParameter['restartReaders'] = restartReaders;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postProcessorConfigDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PostprocessorApi - functional programming interface
 * @export
 */
export const PostprocessorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PostprocessorApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Delete postprocessor config by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConfig(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConfig(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostprocessorApi.deleteConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get all postprocessor configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConfigs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostProcessorConfigDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllConfigs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostprocessorApi.getAllConfigs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get All Schemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPostProcessorSchemas(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPostProcessorSchemas(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostprocessorApi.getAllPostProcessorSchemas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get postprocessor config by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfig(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostProcessorConfigDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfig(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostprocessorApi.getConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Schema
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostProcessorSchema(schema: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostProcessorSchema(schema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostprocessorApi.getPostProcessorSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Supported Post Processors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedPostProcessors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostProcessorDescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedPostProcessors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostprocessorApi.getSupportedPostProcessors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Set postprocessor config by id
         * @param {PostProcessorConfigDTO} postProcessorConfigDTO
         * @param {boolean} [restartReaders]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setConfig(postProcessorConfigDTO: PostProcessorConfigDTO, restartReaders?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setConfig(postProcessorConfigDTO, restartReaders, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PostprocessorApi.setConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PostprocessorApi - factory interface
 * @export
 */
export const PostprocessorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PostprocessorApiFp(configuration)
    return {
        /**
         *
         * @summary Delete postprocessor config by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfig(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteConfig(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all postprocessor configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConfigs(options?: RawAxiosRequestConfig): AxiosPromise<Array<PostProcessorConfigDTO>> {
            return localVarFp.getAllConfigs(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get All Schemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPostProcessorSchemas(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getAllPostProcessorSchemas(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get postprocessor config by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PostProcessorConfigDTO> {
            return localVarFp.getConfig(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Schema
         * @param {string} schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostProcessorSchema(schema: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getPostProcessorSchema(schema, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Supported Post Processors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedPostProcessors(options?: RawAxiosRequestConfig): AxiosPromise<Array<PostProcessorDescription>> {
            return localVarFp.getSupportedPostProcessors(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set postprocessor config by id
         * @param {PostProcessorConfigDTO} postProcessorConfigDTO
         * @param {boolean} [restartReaders]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConfig(postProcessorConfigDTO: PostProcessorConfigDTO, restartReaders?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setConfig(postProcessorConfigDTO, restartReaders, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PostprocessorApi - object-oriented interface
 * @export
 * @class PostprocessorApi
 * @extends {BaseAPI}
 */
export class PostprocessorApi extends BaseAPI {
    /**
     *
     * @summary Delete postprocessor config by id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostprocessorApi
     */
    public deleteConfig(id: string, options?: RawAxiosRequestConfig) {
        return PostprocessorApiFp(this.configuration).deleteConfig(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all postprocessor configs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostprocessorApi
     */
    public getAllConfigs(options?: RawAxiosRequestConfig) {
        return PostprocessorApiFp(this.configuration).getAllConfigs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get All Schemas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostprocessorApi
     */
    public getAllPostProcessorSchemas(options?: RawAxiosRequestConfig) {
        return PostprocessorApiFp(this.configuration).getAllPostProcessorSchemas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get postprocessor config by id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostprocessorApi
     */
    public getConfig(id: string, options?: RawAxiosRequestConfig) {
        return PostprocessorApiFp(this.configuration).getConfig(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Schema
     * @param {string} schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostprocessorApi
     */
    public getPostProcessorSchema(schema: string, options?: RawAxiosRequestConfig) {
        return PostprocessorApiFp(this.configuration).getPostProcessorSchema(schema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Supported Post Processors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostprocessorApi
     */
    public getSupportedPostProcessors(options?: RawAxiosRequestConfig) {
        return PostprocessorApiFp(this.configuration).getSupportedPostProcessors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Set postprocessor config by id
     * @param {PostProcessorConfigDTO} postProcessorConfigDTO
     * @param {boolean} [restartReaders]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostprocessorApi
     */
    public setConfig(postProcessorConfigDTO: PostProcessorConfigDTO, restartReaders?: boolean, options?: RawAxiosRequestConfig) {
        return PostprocessorApiFp(this.configuration).setConfig(postProcessorConfigDTO, restartReaders, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductTemplatesApi - axios parameter creator
 * @export
 */
export const ProductTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Product Entries Batch
         * @param {Array<EntryBatchModifyRequest>} entryBatchModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasABatchDataPost: async (entryBatchModifyRequest: Array<EntryBatchModifyRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryBatchModifyRequest' is not null or undefined
            assertParamExists('restEasasABatchDataPost', 'entryBatchModifyRequest', entryBatchModifyRequest)
            const localVarPath = `/rest/easas/{_a}/batch/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entryBatchModifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Ingest Entry Data
         * @param {ProductEntriesUpdateModel} productEntriesUpdateModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasADataPost: async (productEntriesUpdateModel: ProductEntriesUpdateModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productEntriesUpdateModel' is not null or undefined
            assertParamExists('restEasasADataPost', 'productEntriesUpdateModel', productEntriesUpdateModel)
            const localVarPath = `/rest/easas/{_a}/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productEntriesUpdateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Product Template Infos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAInfosGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/easas/{_a}/infos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Product Template Info
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAInfosIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restEasasAInfosIdGet', 'id', id)
            const localVarPath = `/rest/easas/{_a}/infos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Product Template Data As Foreign Keys
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefAsForeignKeysGet: async (productTemplateRef: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productTemplateRef' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefAsForeignKeysGet', 'productTemplateRef', productTemplateRef)
            const localVarPath = `/rest/easas/{_a}/{productTemplateRef}/asForeignKeys`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Product Template Data
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefDataGet: async (productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productTemplateRef' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefDataGet', 'productTemplateRef', productTemplateRef)
            const localVarPath = `/rest/easas/{_a}/{productTemplateRef}/data`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Product Entry
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} productEntryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefDataPost: async (productTemplateRef: string, productEntryData: Array<ProductEntryData>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productTemplateRef' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefDataPost', 'productTemplateRef', productTemplateRef)
            // verify required parameter 'productEntryData' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefDataPost', 'productEntryData', productEntryData)
            const localVarPath = `/rest/easas/{_a}/{productTemplateRef}/data`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productEntryData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Product Entries By Filter
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefDeleteByFilterDelete: async (productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productTemplateRef' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefDeleteByFilterDelete', 'productTemplateRef', productTemplateRef)
            const localVarPath = `/rest/easas/{_a}/{productTemplateRef}/delete-by-filter`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Product Entry
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} productEntryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefEntryIdDelete: async (entryId: string, productTemplateRef: string, productEntryData: Array<ProductEntryData>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefEntryIdDelete', 'entryId', entryId)
            // verify required parameter 'productTemplateRef' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefEntryIdDelete', 'productTemplateRef', productTemplateRef)
            // verify required parameter 'productEntryData' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefEntryIdDelete', 'productEntryData', productEntryData)
            const localVarPath = `/rest/easas/{_a}/{productTemplateRef}/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productEntryData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch Product Entry
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} productEntryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefEntryIdPatch: async (entryId: string, productTemplateRef: string, productEntryData: Array<ProductEntryData>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefEntryIdPatch', 'entryId', entryId)
            // verify required parameter 'productTemplateRef' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefEntryIdPatch', 'productTemplateRef', productTemplateRef)
            // verify required parameter 'productEntryData' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefEntryIdPatch', 'productEntryData', productEntryData)
            const localVarPath = `/rest/easas/{_a}/{productTemplateRef}/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productEntryData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Wipe All Product Entries
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefWipeAllDelete: async (productTemplateRef: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productTemplateRef' is not null or undefined
            assertParamExists('restEasasAProductTemplateRefWipeAllDelete', 'productTemplateRef', productTemplateRef)
            const localVarPath = `/rest/easas/{_a}/{productTemplateRef}/wipe-all`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Entry Id
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasARefIdGet: async (ref: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('restEasasARefIdGet', 'ref', ref)
            const localVarPath = `/rest/easas/{_a}/{ref}/id`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Data Batch
         * @param {PythonProductTemplateData} pythonProductTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAUpdateDataBatchPost: async (pythonProductTemplateData: PythonProductTemplateData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pythonProductTemplateData' is not null or undefined
            assertParamExists('restEasasAUpdateDataBatchPost', 'pythonProductTemplateData', pythonProductTemplateData)
            const localVarPath = `/rest/easas/{_a}/update-data-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pythonProductTemplateData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Product Template Data Paginated
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAV2ProductTemplateRefDataGet: async (productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productTemplateRef' is not null or undefined
            assertParamExists('restEasasAV2ProductTemplateRefDataGet', 'productTemplateRef', productTemplateRef)
            const localVarPath = `/rest/easas/{_a}/v2/{productTemplateRef}/data`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTemplatesApi - functional programming interface
 * @export
 */
export const ProductTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Product Entries Batch
         * @param {Array<EntryBatchModifyRequest>} entryBatchModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasABatchDataPost(entryBatchModifyRequest: Array<EntryBatchModifyRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductEntryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasABatchDataPost(entryBatchModifyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasABatchDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Ingest Entry Data
         * @param {ProductEntriesUpdateModel} productEntriesUpdateModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasADataPost(productEntriesUpdateModel: ProductEntriesUpdateModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasADataPost(productEntriesUpdateModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasADataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Product Template Infos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAInfosGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductTemplateInfoDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAInfosGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAInfosGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Product Template Info
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAInfosIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTemplateInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAInfosIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAInfosIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Product Template Data As Foreign Keys
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAProductTemplateRefAsForeignKeysGet(productTemplateRef: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ForeignProductEntryKey>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAProductTemplateRefAsForeignKeysGet(productTemplateRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAProductTemplateRefAsForeignKeysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Product Template Data
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAProductTemplateRefDataGet(productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductEntryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAProductTemplateRefDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create Product Entry
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} productEntryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAProductTemplateRefDataPost(productTemplateRef: string, productEntryData: Array<ProductEntryData>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEntryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAProductTemplateRefDataPost(productTemplateRef, productEntryData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAProductTemplateRefDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Product Entries By Filter
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAProductTemplateRefDeleteByFilterDelete(productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductEntryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAProductTemplateRefDeleteByFilterDelete(productTemplateRef, dateFrom, dateTo, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAProductTemplateRefDeleteByFilterDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete Product Entry
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} productEntryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAProductTemplateRefEntryIdDelete(entryId: string, productTemplateRef: string, productEntryData: Array<ProductEntryData>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEntryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAProductTemplateRefEntryIdDelete(entryId, productTemplateRef, productEntryData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAProductTemplateRefEntryIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch Product Entry
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} productEntryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAProductTemplateRefEntryIdPatch(entryId: string, productTemplateRef: string, productEntryData: Array<ProductEntryData>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEntryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAProductTemplateRefEntryIdPatch(entryId, productTemplateRef, productEntryData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAProductTemplateRefEntryIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Wipe All Product Entries
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAProductTemplateRefWipeAllDelete(productTemplateRef: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAProductTemplateRefWipeAllDelete(productTemplateRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAProductTemplateRefWipeAllDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Entry Id
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasARefIdGet(ref: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasARefIdGet(ref, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasARefIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update Data Batch
         * @param {PythonProductTemplateData} pythonProductTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAUpdateDataBatchPost(pythonProductTemplateData: PythonProductTemplateData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PythonProductTemplateData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAUpdateDataBatchPost(pythonProductTemplateData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAUpdateDataBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Product Template Data Paginated
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restEasasAV2ProductTemplateRefDataGet(productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResultListProductEntryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restEasasAV2ProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductTemplatesApi.restEasasAV2ProductTemplateRefDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductTemplatesApi - factory interface
 * @export
 */
export const ProductTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductTemplatesApiFp(configuration)
    return {
        /**
         *
         * @summary Create Product Entries Batch
         * @param {Array<EntryBatchModifyRequest>} entryBatchModifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasABatchDataPost(entryBatchModifyRequest: Array<EntryBatchModifyRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductEntryDTO>> {
            return localVarFp.restEasasABatchDataPost(entryBatchModifyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Ingest Entry Data
         * @param {ProductEntriesUpdateModel} productEntriesUpdateModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasADataPost(productEntriesUpdateModel: ProductEntriesUpdateModel, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.restEasasADataPost(productEntriesUpdateModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Product Template Infos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAInfosGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductTemplateInfoDTO>> {
            return localVarFp.restEasasAInfosGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Product Template Info
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAInfosIdGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductTemplateInfoDTO> {
            return localVarFp.restEasasAInfosIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Product Template Data As Foreign Keys
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefAsForeignKeysGet(productTemplateRef: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ForeignProductEntryKey>> {
            return localVarFp.restEasasAProductTemplateRefAsForeignKeysGet(productTemplateRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Product Template Data
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefDataGet(productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductEntryDTO>> {
            return localVarFp.restEasasAProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Product Entry
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} productEntryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefDataPost(productTemplateRef: string, productEntryData: Array<ProductEntryData>, options?: RawAxiosRequestConfig): AxiosPromise<ProductEntryDTO> {
            return localVarFp.restEasasAProductTemplateRefDataPost(productTemplateRef, productEntryData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Product Entries By Filter
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefDeleteByFilterDelete(productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductEntryDTO>> {
            return localVarFp.restEasasAProductTemplateRefDeleteByFilterDelete(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Product Entry
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} productEntryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefEntryIdDelete(entryId: string, productTemplateRef: string, productEntryData: Array<ProductEntryData>, options?: RawAxiosRequestConfig): AxiosPromise<ProductEntryDTO> {
            return localVarFp.restEasasAProductTemplateRefEntryIdDelete(entryId, productTemplateRef, productEntryData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch Product Entry
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<ProductEntryData>} productEntryData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefEntryIdPatch(entryId: string, productTemplateRef: string, productEntryData: Array<ProductEntryData>, options?: RawAxiosRequestConfig): AxiosPromise<ProductEntryDTO> {
            return localVarFp.restEasasAProductTemplateRefEntryIdPatch(entryId, productTemplateRef, productEntryData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Wipe All Product Entries
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAProductTemplateRefWipeAllDelete(productTemplateRef: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restEasasAProductTemplateRefWipeAllDelete(productTemplateRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Entry Id
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasARefIdGet(ref: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.restEasasARefIdGet(ref, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Data Batch
         * @param {PythonProductTemplateData} pythonProductTemplateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAUpdateDataBatchPost(pythonProductTemplateData: PythonProductTemplateData, options?: RawAxiosRequestConfig): AxiosPromise<PythonProductTemplateData> {
            return localVarFp.restEasasAUpdateDataBatchPost(pythonProductTemplateData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Product Template Data Paginated
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restEasasAV2ProductTemplateRefDataGet(productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResultListProductEntryDTO> {
            return localVarFp.restEasasAV2ProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, offset, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductTemplatesApi - object-oriented interface
 * @export
 * @class ProductTemplatesApi
 * @extends {BaseAPI}
 */
export class ProductTemplatesApi extends BaseAPI {
    /**
     *
     * @summary Create Product Entries Batch
     * @param {Array<EntryBatchModifyRequest>} entryBatchModifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasABatchDataPost(entryBatchModifyRequest: Array<EntryBatchModifyRequest>, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasABatchDataPost(entryBatchModifyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Ingest Entry Data
     * @param {ProductEntriesUpdateModel} productEntriesUpdateModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasADataPost(productEntriesUpdateModel: ProductEntriesUpdateModel, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasADataPost(productEntriesUpdateModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Product Template Infos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAInfosGet(options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAInfosGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Product Template Info
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAInfosIdGet(id: number, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAInfosIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Product Template Data As Foreign Keys
     * @param {string} productTemplateRef
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAProductTemplateRefAsForeignKeysGet(productTemplateRef: string, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAProductTemplateRefAsForeignKeysGet(productTemplateRef, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Product Template Data
     * @param {string} productTemplateRef
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAProductTemplateRefDataGet(productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create Product Entry
     * @param {string} productTemplateRef
     * @param {Array<ProductEntryData>} productEntryData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAProductTemplateRefDataPost(productTemplateRef: string, productEntryData: Array<ProductEntryData>, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAProductTemplateRefDataPost(productTemplateRef, productEntryData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Product Entries By Filter
     * @param {string} productTemplateRef
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAProductTemplateRefDeleteByFilterDelete(productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAProductTemplateRefDeleteByFilterDelete(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Product Entry
     * @param {string} entryId
     * @param {string} productTemplateRef
     * @param {Array<ProductEntryData>} productEntryData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAProductTemplateRefEntryIdDelete(entryId: string, productTemplateRef: string, productEntryData: Array<ProductEntryData>, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAProductTemplateRefEntryIdDelete(entryId, productTemplateRef, productEntryData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Patch Product Entry
     * @param {string} entryId
     * @param {string} productTemplateRef
     * @param {Array<ProductEntryData>} productEntryData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAProductTemplateRefEntryIdPatch(entryId: string, productTemplateRef: string, productEntryData: Array<ProductEntryData>, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAProductTemplateRefEntryIdPatch(entryId, productTemplateRef, productEntryData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Wipe All Product Entries
     * @param {string} productTemplateRef
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAProductTemplateRefWipeAllDelete(productTemplateRef: string, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAProductTemplateRefWipeAllDelete(productTemplateRef, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Entry Id
     * @param {string} ref
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasARefIdGet(ref: string, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasARefIdGet(ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Data Batch
     * @param {PythonProductTemplateData} pythonProductTemplateData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAUpdateDataBatchPost(pythonProductTemplateData: PythonProductTemplateData, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAUpdateDataBatchPost(pythonProductTemplateData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Product Template Data Paginated
     * @param {string} productTemplateRef
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [filter]
     * @param {number} [offset]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTemplatesApi
     */
    public restEasasAV2ProductTemplateRefDataGet(productTemplateRef: string, dateFrom?: string, dateTo?: string, filter?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return ProductTemplatesApiFp(this.configuration).restEasasAV2ProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, offset, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestingApi - axios parameter creator
 * @export
 */
export const TestingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Run Data
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunData: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getRunData', 'runId', runId)
            const localVarPath = `/rest/testing/getRunData/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Run Exists
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runExists: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('runExists', 'runId', runId)
            const localVarPath = `/rest/testing/runExists/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Start Run
         * @param {string} body
         * @param {DataHoldMode} [dataHoldMode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRun: async (body: string, dataHoldMode?: DataHoldMode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('startRun', 'body', body)
            const localVarPath = `/rest/testing/startRun`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dataHoldMode !== undefined) {
                for (const [key, value] of Object.entries(dataHoldMode)) {
                    localVarQueryParameter[key] = value;
                }
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Stop Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('stopRun', 'runId', runId)
            const localVarPath = `/rest/testing/stopRun/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Test Meter Filter
         * @param {MeterFilterConfig} meterFilterConfig
         * @param {boolean} [enabledOnly]
         * @param {ReaderType} [readerType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMeterFilter: async (meterFilterConfig: MeterFilterConfig, enabledOnly?: boolean, readerType?: ReaderType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meterFilterConfig' is not null or undefined
            assertParamExists('testMeterFilter', 'meterFilterConfig', meterFilterConfig)
            const localVarPath = `/rest/testing/testMeterFilter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (enabledOnly !== undefined) {
                localVarQueryParameter['enabledOnly'] = enabledOnly;
            }

            if (readerType !== undefined) {
                for (const [key, value] of Object.entries(readerType)) {
                    localVarQueryParameter[key] = value;
                }
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meterFilterConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Test Tag Mapper
         * @param {TagMapperTestRequest} tagMapperTestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testTagMapper: async (tagMapperTestRequest: TagMapperTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagMapperTestRequest' is not null or undefined
            assertParamExists('testTagMapper', 'tagMapperTestRequest', tagMapperTestRequest)
            const localVarPath = `/rest/testing/testTagMapper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagMapperTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestingApi - functional programming interface
 * @export
 */
export const TestingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestingApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Run Data
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunData(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Measurement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunData(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingApi.getRunData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Run Exists
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runExists(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runExists(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingApi.runExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Start Run
         * @param {string} body
         * @param {DataHoldMode} [dataHoldMode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startRun(body: string, dataHoldMode?: DataHoldMode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startRun(body, dataHoldMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingApi.startRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Stop Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingApi.stopRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Test Meter Filter
         * @param {MeterFilterConfig} meterFilterConfig
         * @param {boolean} [enabledOnly]
         * @param {ReaderType} [readerType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testMeterFilter(meterFilterConfig: MeterFilterConfig, enabledOnly?: boolean, readerType?: ReaderType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testMeterFilter(meterFilterConfig, enabledOnly, readerType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingApi.testMeterFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Test Tag Mapper
         * @param {TagMapperTestRequest} tagMapperTestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testTagMapper(tagMapperTestRequest: TagMapperTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testTagMapper(tagMapperTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingApi.testTagMapper']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestingApi - factory interface
 * @export
 */
export const TestingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestingApiFp(configuration)
    return {
        /**
         *
         * @summary Get Run Data
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunData(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Measurement>> {
            return localVarFp.getRunData(runId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Run Exists
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runExists(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.runExists(runId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start Run
         * @param {string} body
         * @param {DataHoldMode} [dataHoldMode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRun(body: string, dataHoldMode?: DataHoldMode, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.startRun(body, dataHoldMode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Stop Run
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stopRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Test Meter Filter
         * @param {MeterFilterConfig} meterFilterConfig
         * @param {boolean} [enabledOnly]
         * @param {ReaderType} [readerType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMeterFilter(meterFilterConfig: MeterFilterConfig, enabledOnly?: boolean, readerType?: ReaderType, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.testMeterFilter(meterFilterConfig, enabledOnly, readerType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Test Tag Mapper
         * @param {TagMapperTestRequest} tagMapperTestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testTagMapper(tagMapperTestRequest: TagMapperTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.testTagMapper(tagMapperTestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestingApi - object-oriented interface
 * @export
 * @class TestingApi
 * @extends {BaseAPI}
 */
export class TestingApi extends BaseAPI {
    /**
     *
     * @summary Get Run Data
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestingApi
     */
    public getRunData(runId: string, options?: RawAxiosRequestConfig) {
        return TestingApiFp(this.configuration).getRunData(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Run Exists
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestingApi
     */
    public runExists(runId: string, options?: RawAxiosRequestConfig) {
        return TestingApiFp(this.configuration).runExists(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Start Run
     * @param {string} body
     * @param {DataHoldMode} [dataHoldMode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestingApi
     */
    public startRun(body: string, dataHoldMode?: DataHoldMode, options?: RawAxiosRequestConfig) {
        return TestingApiFp(this.configuration).startRun(body, dataHoldMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Stop Run
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestingApi
     */
    public stopRun(runId: string, options?: RawAxiosRequestConfig) {
        return TestingApiFp(this.configuration).stopRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Test Meter Filter
     * @param {MeterFilterConfig} meterFilterConfig
     * @param {boolean} [enabledOnly]
     * @param {ReaderType} [readerType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestingApi
     */
    public testMeterFilter(meterFilterConfig: MeterFilterConfig, enabledOnly?: boolean, readerType?: ReaderType, options?: RawAxiosRequestConfig) {
        return TestingApiFp(this.configuration).testMeterFilter(meterFilterConfig, enabledOnly, readerType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Test Tag Mapper
     * @param {TagMapperTestRequest} tagMapperTestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestingApi
     */
    public testTagMapper(tagMapperTestRequest: TagMapperTestRequest, options?: RawAxiosRequestConfig) {
        return TestingApiFp(this.configuration).testTagMapper(tagMapperTestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ToolsApi - axios parameter creator
 * @export
 */
export const ToolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Output
         * @param {string} runId
         * @param {number} [since]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutput: async (runId: string, since?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getOutput', 'runId', runId)
            const localVarPath = `/rest/tools/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Kill
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        killRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('killRun', 'runId', runId)
            const localVarPath = `/rest/tools/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Start Ping
         * @param {PingParameters} pingParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPing: async (pingParameters: PingParameters, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pingParameters' is not null or undefined
            assertParamExists('startPing', 'pingParameters', pingParameters)
            const localVarPath = `/rest/tools/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pingParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Start Traceroute
         * @param {TracerouteParameters} tracerouteParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTraceroute: async (tracerouteParameters: TracerouteParameters, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tracerouteParameters' is not null or undefined
            assertParamExists('startTraceroute', 'tracerouteParameters', tracerouteParameters)
            const localVarPath = `/rest/tools/traceroute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tracerouteParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ToolsApi - functional programming interface
 * @export
 */
export const ToolsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ToolsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Output
         * @param {string} runId
         * @param {number} [since]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutput(runId: string, since?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutput(runId, since, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.getOutput']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Kill
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async killRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.killRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.killRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Start Ping
         * @param {PingParameters} pingParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startPing(pingParameters: PingParameters, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startPing(pingParameters, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.startPing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Start Traceroute
         * @param {TracerouteParameters} tracerouteParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startTraceroute(tracerouteParameters: TracerouteParameters, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startTraceroute(tracerouteParameters, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.startTraceroute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ToolsApi - factory interface
 * @export
 */
export const ToolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ToolsApiFp(configuration)
    return {
        /**
         *
         * @summary Get Output
         * @param {string} runId
         * @param {number} [since]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutput(runId: string, since?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getOutput(runId, since, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Kill
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        killRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.killRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start Ping
         * @param {PingParameters} pingParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPing(pingParameters: PingParameters, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.startPing(pingParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start Traceroute
         * @param {TracerouteParameters} tracerouteParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTraceroute(tracerouteParameters: TracerouteParameters, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.startTraceroute(tracerouteParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ToolsApi - object-oriented interface
 * @export
 * @class ToolsApi
 * @extends {BaseAPI}
 */
export class ToolsApi extends BaseAPI {
    /**
     *
     * @summary Get Output
     * @param {string} runId
     * @param {number} [since]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public getOutput(runId: string, since?: number, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).getOutput(runId, since, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Kill
     * @param {string} runId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public killRun(runId: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).killRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Start Ping
     * @param {PingParameters} pingParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public startPing(pingParameters: PingParameters, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).startPing(pingParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Start Traceroute
     * @param {TracerouteParameters} tracerouteParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public startTraceroute(tracerouteParameters: TracerouteParameters, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).startTraceroute(tracerouteParameters, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VersionApi - axios parameter creator
 * @export
 */
export const VersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersion: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Version Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest/version/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionApi - functional programming interface
 * @export
 */
export const VersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VersionApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersion(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionApi.getVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get Version Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VersionInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionApi.getVersionInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VersionApi - factory interface
 * @export
 */
export const VersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VersionApiFp(configuration)
    return {
        /**
         *
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersion(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getVersion(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Version Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionInfo(options?: RawAxiosRequestConfig): AxiosPromise<VersionInfo> {
            return localVarFp.getVersionInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionApi - object-oriented interface
 * @export
 * @class VersionApi
 * @extends {BaseAPI}
 */
export class VersionApi extends BaseAPI {
    /**
     *
     * @summary Get Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionApi
     */
    public getVersion(options?: RawAxiosRequestConfig) {
        return VersionApiFp(this.configuration).getVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Version Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionApi
     */
    public getVersionInfo(options?: RawAxiosRequestConfig) {
        return VersionApiFp(this.configuration).getVersionInfo(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WriteApi - axios parameter creator
 * @export
 */
export const WriteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Writer given measurements to database
         * @summary Write Measurements
         * @param {Array<Measurement>} measurement measurements to write
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeMeasurements: async (measurement: Array<Measurement>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurement' is not null or undefined
            assertParamExists('writeMeasurements', 'measurement', measurement)
            const localVarPath = `/rest/write/measurements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(measurement, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Writer given product items to database
         * @summary Write Product Items
         * @param {ProductEntries} productEntries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeProductItems: async (productEntries: ProductEntries, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productEntries' is not null or undefined
            assertParamExists('writeProductItems', 'productEntries', productEntries)
            const localVarPath = `/rest/write/productItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productEntries, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WriteApi - functional programming interface
 * @export
 */
export const WriteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WriteApiAxiosParamCreator(configuration)
    return {
        /**
         * Writer given measurements to database
         * @summary Write Measurements
         * @param {Array<Measurement>} measurement measurements to write
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async writeMeasurements(measurement: Array<Measurement>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.writeMeasurements(measurement, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WriteApi.writeMeasurements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Writer given product items to database
         * @summary Write Product Items
         * @param {ProductEntries} productEntries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async writeProductItems(productEntries: ProductEntries, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.writeProductItems(productEntries, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WriteApi.writeProductItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WriteApi - factory interface
 * @export
 */
export const WriteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WriteApiFp(configuration)
    return {
        /**
         * Writer given measurements to database
         * @summary Write Measurements
         * @param {Array<Measurement>} measurement measurements to write
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeMeasurements(measurement: Array<Measurement>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.writeMeasurements(measurement, options).then((request) => request(axios, basePath));
        },
        /**
         * Writer given product items to database
         * @summary Write Product Items
         * @param {ProductEntries} productEntries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeProductItems(productEntries: ProductEntries, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.writeProductItems(productEntries, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WriteApi - object-oriented interface
 * @export
 * @class WriteApi
 * @extends {BaseAPI}
 */
export class WriteApi extends BaseAPI {
    /**
     * Writer given measurements to database
     * @summary Write Measurements
     * @param {Array<Measurement>} measurement measurements to write
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteApi
     */
    public writeMeasurements(measurement: Array<Measurement>, options?: RawAxiosRequestConfig) {
        return WriteApiFp(this.configuration).writeMeasurements(measurement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Writer given product items to database
     * @summary Write Product Items
     * @param {ProductEntries} productEntries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteApi
     */
    public writeProductItems(productEntries: ProductEntries, options?: RawAxiosRequestConfig) {
        return WriteApiFp(this.configuration).writeProductItems(productEntries, options).then((request) => request(this.axios, this.basePath));
    }
}



